import { serviceCatalogFr, serviceCatalogAr, serviceCatalogEn } from './serviceCatalog';
import { translatorsFr, translatorsAr, translatorsEn } from './translators';
import { quoteWizardFr, quoteWizardAr, quoteWizardEn } from './quoteWizard';
import { quoteFormFr, quoteFormAr, quoteFormEn } from './quoteForm';
import { dashboardFr, dashboardAr, dashboardEn } from './dashboard';

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      translation: 'Traduction',
      certifiedTranslation: 'Traduction certifiée',
      professionalTranslation: 'Traduction professionnelle',
      interpreting: 'Interprétariat',
      documents: 'Documents',
      order: 'Commander en ligne',
      howItWorks: 'Comment ça marche',
      faq: 'FAQ',
      about: 'À propos',
      contact: 'Contact',
      translator: 'Devenir traducteur',
      translators: 'Notre réseau',
      orderNow: 'Commander en ligne',
      login: 'Connexion',
      menu: 'Menu',
      language: 'Langue',
      topMessage: 'Vos documents officiels traduits et certifiés — PDF + originaux sur demande ✦',
      viewAllServices: 'Toutes les traductions',
      viewAllInterpreting: 'Tout l\'interprétariat',
      viewMore: 'Voir tout',
      servicesCategoriesLabel: 'Spécialités de traduction',
      servicesMenu: {
        specialtiesTitle: 'Services',
        professionalGroup: 'Traduction professionnelle',
        officialGroup: 'Traduction officielle',
        documentsGroup: 'Documents',
        interpretingGroup: 'Interprétariat',
        otherGroup: 'Autres services',
        general: 'Traduction générale',
        specialized: 'Traduction spécialisée',
        legal: 'Traduction juridique',
        technical: 'Traduction technique',
        medical: 'Traduction médicale',
        financial: 'Traduction financière',
        commercial: 'Traduction commerciale',
        marketing: 'Traduction marketing',
        tourism: 'Traduction touristique',
        sworn: 'Traduction assermentée',
        certified: 'Traduction certifiée',
        legalization: 'Légalisation',
        apostille: 'Apostille',
        personal: 'Documents personnels',
        administrative: 'Documents administratifs',
        academic: 'Diplômes & certificats',
        legalDocs: 'Documents juridiques',
        commercialDocs: 'Documents commerciaux',
        medicalDocs: 'Documents médicaux',
        simultaneous: 'Interprétariat simultané',
        consecutive: 'Interprétariat consécutif',
        liaison: 'Interprétariat de liaison',
        judicial: 'Interprétariat judiciaire',
        medicalInterpreting: 'Interprétariat médical',
        businessInterpreting: 'Interprétariat en entreprise',
        remoteInterpreting: 'Interprétariat à distance',
        phone: 'Téléphonique',
        video: 'Visioconférence',
        transcription: 'Transcription et retranscription',
        voiceover: 'Voice-over',
      },
      otherServices: 'Autres services',
    },
    hero: {
      title: 'VOS DOCUMENTS OFFICIELS TRADUITS RAPIDEMENT//À UN [PRIX IMBATTABLE]',
      subtitle:
        'Confiez vos démarches administratives à des traducteurs assermentés et gagnez du temps.',
      cta: 'JE COMMANDE EN LIGNE',
      ctaSecondary: 'VOIR LES SERVICES',
      trust: 'Vos traductions certifiées réalisées par des experts assermentés, livrées en PDF en moins de 48h avec Tarjemlek.',
    },
    stats: {
      words: 'Mots traduits',
      pages: 'Pages certifiées',
      clients: 'Clients satisfaits',
      languages: 'Langues disponibles',
    },
    languagesCountries: {
      title: 'Langues et pays couverts',
      subtitle: 'Traduction professionnelle dans plus de 170 langues et attestation pour plus de 70 pays à travers le monde',
      languagesTitle: 'Langues',
      countriesTitle: 'Pays',
      hubLabel: 'Siège — Tunis',
      moreLanguages: '170+ langues',
      moreCountries: '70+ pays',
      mapHint: 'Survolez un pays en surbrillance',
      langContactHint: 'Vous ne trouvez pas votre combinaison de langues ?',
      langContactAction: 'Contactez-nous',
      mapLoading: 'Chargement de la carte…',
      mapError: 'Impossible de charger la carte.',
      tunisia: 'Tunisie',
      france: 'France',
      uk: 'Royaume-Uni',
      germany: 'Allemagne',
      spain: 'Espagne',
      italy: 'Italie',
      morocco: 'Maroc',
      algeria: 'Algérie',
      libya: 'Libye',
      egypt: 'Égypte',
      uae: 'Émirats arabes unis',
      saudi: 'Arabie saoudite',
      usa: 'États-Unis',
      canada: 'Canada',
      brazil: 'Brésil',
      australia: 'Australie',
      india: 'Inde',
      china: 'Chine',
      japan: 'Japon',
      turkey: 'Turquie',
      belgium: 'Belgique',
      switzerland: 'Suisse',
      portugal: 'Portugal',
      greece: 'Grèce',
      russia: 'Russie',
      colombia: 'Colombie',
      chile: 'Chili',
      argentina: 'Argentine',
      sudan: 'Soudan',
      ethiopia: 'Éthiopie',
      kenya: 'Kenya',
      tanzania: 'Tanzanie',
      southAfrica: 'Afrique du Sud',
      senegal: 'Sénégal',
      ghana: 'Ghana',
      nigeria: 'Nigeria',
      jordan: 'Jordanie',
      iraq: 'Irak',
      iran: 'Iran',
      yemen: 'Yémen',
      oman: 'Oman',
      southKorea: 'Corée du Sud',
      thailand: 'Thaïlande',
      vietnam: 'Vietnam',
      malaysia: 'Malaisie',
      indonesia: 'Indonésie',
      philippines: 'Philippines',
      newZealand: 'Nouvelle-Zélande',
    },
    steps: {
      title: 'COMMENT ÇA MARCHE',
      subtitle: 'Quatre étapes simples pour obtenir votre traduction certifiée',
      step1Title: 'Sélectionnez votre document',
      step1Items: [
        'Sélectionnez le type de document à traduire.',
        'Choisissez la combinaison de langues requise.',
        'Indiquez le nombre de pages à traduire.',
      ],
      step2Title: 'Téléversez votre document',
      step2Desc: 'Envoyez le scan ou la photo de votre document original.',
      step3Title: 'Payez en ligne',
      step3Desc: 'Paiement 100% sécurisé.',
      step4Title: 'Recevez votre traduction certifiée',
      step4Desc:
        'Recevez votre traduction officielle par email en 48 heures maximum, au format PDF.',
      orderOnline: 'Je commande en ligne',
    },
    workProcess: {
      kicker: 'Traduction en ligne, simple et rapide',
      title: 'Comment nous réalisons votre travail ?',
      intro:
        'Chez Tarjemlek, la communication, le respect des délais et la qualité passent avant tout. Nous suivons un processus clair et transparent pour vous livrer une traduction irréprochable dès la première fois — quel que soit le volume ou l\'urgence de votre demande.',
      steps: [
        {
          title: 'Devis',
          text: 'Dès réception de votre document, nous vous annonçons le prix et le délai en quelques minutes, pour validation de votre part.',
        },
        {
          title: 'Traduction',
          text: 'Une fois le devis confirmé, votre dossier est confié à un traducteur assermenté qui maîtrise votre type de document.',
        },
        {
          title: 'Révision',
          text: 'Un relecteur spécialisé de votre domaine vérifie la terminologie, la mise en forme et la conformité à l\'original.',
        },
        {
          title: 'Livraison',
          text: 'Vous recevez votre traduction certifiée par e-mail au format PDF, et nous intégrons vos remarques jusqu\'à la version finale.',
        },
      ],
      cta: 'Envoyer mon document',
    },
    homeZigzag: {
      title: 'Tarjemlek, plateforme de traduction assermentée reconnue',
      subtitle:
        'Toutes les traductions assermentées réalisées via Tarjemlek sont destinées aux administrations tunisiennes et étrangères.',
      row1Title: 'Traducteurs agréés',
      row1Text:
        'Tarjemlek s\'appuie sur des traducteurs assermentés diplômés, polyglottes et expérimentés dans leur spécialité. Chaque dossier est confié à un expert du domaine, pour une traduction précise et adaptée à vos objectifs.',
      row2Title: 'Interprètes qualifiés',
      row2Text:
        'Notre réseau d\'interprètes expérimentés couvre les principales langues pour une communication claire en réunion, en présentiel ou en ligne. Formés dans leur spécialité — juridique, médical, technique ou marketing — ils maîtrisent les formalités d\'interprétation et les événements professionnels.',
    },
    keyFigures: {
      title: 'Tarjemlek en chiffres',
      intro:
        'Depuis plusieurs années, Tarjemlek accompagne particuliers, entreprises et administrations en Tunisie et à l\'étranger avec des traductions assermentées fiables. Que vous cherchiez un partenaire durable pour vos projets de traduction ou une simple traduction officielle de vos documents, notre équipe est à vos côtés.',
      items: [
        { value: '+2 500', label: 'Pages certifiées' },
        { value: '+15', label: 'Langues' },
        { value: '+50', label: 'Traducteurs assermentés' },
        { value: '+1 200', label: 'Clients satisfaits' },
      ],
      cta: 'Demander une traduction',
    },
    homeLanguages: {
      title: 'Quelles langues traduisons-nous ?',
      intro:
        'Nous traduisons vos documents dans toutes les langues du monde pour répondre à tous vos besoins, grâce à un réseau de traducteurs professionnels en Tunisie et à l\'étranger. Voici quelques-unes de nos langues les plus demandées :',
      moreLanguages: 'Plus de langues',
      featured: [
        { code: 'fr', name: 'Français' },
        { code: 'gb', name: 'Anglais' },
        { code: 'it', name: 'Italien' },
        { code: 'de', name: 'Allemand' },
        { code: 'tn', name: 'Arabe' },
      ],
    },
    languagesPage: {
      title: 'Nos langues de traduction',
      subtitle:
        'Traduction assermentée et professionnelle dans les principales paires de langues. Votre combinaison n\'apparaît pas ? Contactez-nous.',
      note:
        'Nous couvrons aussi d\'autres langues et combinaisons selon la disponibilité de nos traducteurs. Demandez un devis gratuit pour votre paire de langues.',
      cta: 'Demander un devis',
      contact: 'Nous contacter',
      languages: [
        {
          code: 'fr',
          name: 'Français',
          text: 'Traduction française certifiée pour administrations, ambassades et établissements.',
        },
        {
          code: 'gb',
          name: 'Anglais',
          text: 'Traduction anglaise pour dossiers universitaires, immigration, contrats et entreprises.',
        },
        {
          code: 'it',
          name: 'Italien',
          text: 'Traduction italienne pour documents d\'état civil, études et formalités administratives.',
        },
        {
          code: 'es',
          name: 'Espagnol',
          text: 'Traduction espagnole pour démarches, études et documents professionnels.',
        },
        {
          code: 'de',
          name: 'Allemand',
          text: 'Traduction allemande pour dossiers d\'études, visas, contrats et documents techniques.',
        },
        {
          code: 'tn',
          name: 'Arabe',
          text: 'Traduction assermentée arabe pour documents officiels, juridiques, académiques et commerciaux.',
        },
      ],
    },
    homeFeatured: {
      title: 'Traductions assermentées et interprétariat certifié',
      subtitle: 'Commandez en ligne simplement et rapidement — traduction et interprétation',
      seeMore: 'Voir plus',
      hints: {
        criminal: 'Bulletin n° 3 (B3)',
        invoice: 'STEG, SONEDE, Tunisie Telecom, factures commerciales',
        apostilleDoc: 'Convention de La Haye (1961)',
      },
      invoiceTypes: ['STEG', 'SONEDE', 'Tunisie Telecom', 'Commerciales'],
    },
    whatWeDo: {
      title: 'Que faisons-nous ?',
      items: [
        {
          title: 'Traduction assermentée',
          text: 'Documents officiels certifiés par un traducteur agréé, acceptés par les administrations et ambassades.',
          points: [
            'Actes d\'état civil, diplômes et casiers judiciaires',
            'Dossiers visa, immigration et naturalisation',
            'Livraison PDF certifié sous 48 h (express 24 h)',
          ],
        },
        {
          title: 'Interprétariat',
          text: 'Des interprètes spécialisés pour une communication claire, en présentiel ou à distance.',
          points: [
            'Simultanée, consécutive et de liaison',
            'Judiciaire, médicale et commerciale',
            'Téléphone et visioconférence',
          ],
        },
        {
          title: 'Traduction juridique',
          text: 'Contrats, jugements et actes traduits avec précision et confidentialité.',
          points: [
            'Contrats, statuts et actes notariés',
            'Jugements, procurations et pièces de tribunal',
            'Secret professionnel garanti',
          ],
        },
        {
          title: 'Correspondance commerciale',
          text: 'Vos échanges d\'entreprise traduits avec clarté et professionnalisme.',
          points: [
            'Courriers, e-mails et notes internes',
            'Appels d\'offres, catalogues et propositions',
            'Ton adapté à votre secteur',
          ],
        },
        {
          title: 'Voyages et tourisme',
          text: 'Documents de voyage et contenus touristiques traduits pour des démarches fluides.',
          points: [
            'Visas, réservations et attestations',
            'Guides, menus et sites hôteliers',
            'Contenus adaptés à chaque marché',
          ],
        },
        {
          title: 'Traduction financière',
          text: 'Bilans et rapports traduits avec clarté, transparence et conformité.',
          points: [
            'Bilans, comptes de résultat et rapports',
            'Audits, business plans et dossiers bancaires',
            'Terminologie conforme aux normes',
          ],
        },
        {
          title: 'Traduction technique',
          text: 'Documents techniques traduits avec précision et terminologie cohérente.',
          points: [
            'Manuels, notices et fiches techniques',
            'Cahiers des charges et spécifications',
            'Terminologie cohérente',
          ],
        },
        {
          title: 'Traduction médicale',
          text: 'Documents de santé traduits avec rigueur et confidentialité.',
          points: [
            'Certificats médicaux et comptes rendus',
            'Analyses, ordonnances et dossiers de soins',
            'Secret médical respecté',
          ],
        },
        {
          title: 'Traduction marketing',
          text: 'Contenus qui résonnent auprès de votre public, ton de marque préservé.',
          points: [
            'Campagnes, slogans et contenus digitaux',
            'Brochures, sites vitrines et e-commerce',
            'Adaptation culturelle',
          ],
        },
      ],
    },
    translationTypes: {
      title: 'Nos types de traduction',
      subtitle: 'De la traduction assermentée à la localisation web — une solution pour chaque besoin',
      cta: 'Tous les services',
      orderCta: 'Demander un devis',
      sworn: 'Traduction assermentée',
      swornDesc: 'Documents officiels certifiés par un traducteur agréé — acceptés par les administrations et ambassades.',
      website: 'Traduction de site internet',
      websiteDesc: 'Pages web, e-commerce et interfaces adaptées à votre audience internationale.',
      legal: 'Traduction juridique',
      legalDesc: 'Contrats, jugements, statuts et pièces de procédure traduits avec précision.',
      technical: 'Traduction technique',
      technicalDesc: 'Manuels, notices, spécifications et documentation industrielle.',
      marketing: 'Traduction marketing',
      marketingDesc: 'Brochures, campagnes, contenus digitaux et messages de marque.',
      academic: 'Traduction académique',
      academicDesc: 'Diplômes, thèses, articles scientifiques et dossiers d\'inscription.',
      localization: 'Localisation',
      localizationDesc: 'Adaptation linguistique et culturelle de logiciels, apps et contenus digitaux.',
      subtitling: 'Sous-titrage & média',
      subtitlingDesc: 'Films, vidéos, podcasts et contenus multimédia sous-titrés ou transcrits.',
    },
    homeQuote: {
      title: 'Vous ne trouvez pas votre document ?',
      subtitle: 'Votre combinaison de langues n\'est pas proposée ?',
      text: 'Demandez un devis personnalisé et gratuit. Nous vous répondons sous 30 minutes.',
      cta: 'Demander un devis',
    },
    homeBlog: {
      title: 'Blogs',
      subtitle: 'Conseils et actualités sur la traduction assermentée',
      readMore: 'Lire la suite',
      posts: [
        {
          slug: 'prix-traduction-assermentee',
          title: 'Prix d\'une traduction assermentée | Les meilleurs tarifs',
          excerpt: 'Comprendre les tarifs d\'une traduction certifiée et ce qui influence le devis.',
        },
        {
          slug: 'traduction-document-officiel',
          title: 'Traduction de document officiel | Certifiée en 48 h',
          excerpt: 'Comment obtenir une traduction assermentée rapide pour vos démarches.',
        },
        {
          slug: 'releves-notes-diplomes',
          title: 'Traduction de relevés de notes et diplômes | 4 conseils',
          excerpt: 'Les points clés pour faire traduire vos documents académiques sans rejet.',
        },
      ],
    },
    services: {
      title: 'Nos services de traduction',
      subtitle: 'Solutions pour les Tunisiens à l\'étranger, ambassades, universités et entreprises méditerranéennes',
      legal: 'Traduction juridique',
      legalDesc: 'Contrats, jugements, procédures judiciaires traduits par des experts.',
      certified: 'Traduction certifiée',
      certifiedDesc: 'Traductions certifiées et légalisées acceptées par les administrations.',
      academic: 'Traduction académique',
      academicDesc: 'Diplômes, relevés de notes, thèses pour équivalence et inscription.',
      medical: 'Traduction médicale',
      medicalDesc: 'Dossiers médicaux, certificats de santé pour visa et assurance.',
      commercial: 'Traduction commerciale',
      commercialDesc: 'Statuts, factures, documents d\'entreprise pour création de société.',
      apostille: 'Apostille & légalisation',
      apostilleDesc: 'Accompagnement pour la reconnaissance internationale de vos documents.',
    },
    documents: {
      title: 'Documents les plus demandés',
      subtitle: 'Traductions assermentées à partir de 25 TND / page',
      from: 'À partir de',
      perPage: 'TND / page',
      order: 'Commander',
      birth: 'Acte de naissance',
      marriage: 'Acte de mariage',
      diploma: 'Diplôme universitaire',
      transcript: 'Relevé de notes',
      criminal: 'Casier judiciaire',
      passport: 'Passeport / CIN',
      idcard: 'Carte d\'identité',
      driving: 'Permis de conduire',
      contract: 'Contrat',
      judgment: 'Jugement / Décision',
      power: 'Procuration',
      apostilleDoc: 'Apostille',
    },
    serviceCatalog: serviceCatalogFr,
    servicesHub: {
      heroTitle: 'Nos services de traduction',
      heroSubtitle: 'Une solution adaptée à votre document, votre domaine et vos exigences.',
      heroOrder: 'Commander une traduction',
      heroContact: 'Nous contacter',
      profTitle: 'Traduction professionnelle',
      profIntro: 'Des solutions adaptées à chaque type de document et à chaque secteur d\'activité.',
      officialTitle: 'Traduction officielle',
      officialIntro: 'Pour les documents nécessitant une valeur légale, une certification ou une reconnaissance internationale.',
      docsTitle: 'Documents',
      docsIntro: 'Nous traduisons les documents personnels, administratifs, académiques, juridiques, commerciaux et médicaux.',
      processTitle: 'Comment ça fonctionne ?',
      processIntro: 'Un parcours clair et transparent, de la demande à la livraison.',
      processCta: 'Voir le fonctionnement',
      processSteps: [
        { title: 'Déposez votre document', desc: 'Téléchargez votre document et indiquez les langues souhaitées.' },
        { title: 'Précisez votre besoin', desc: 'Choisissez le domaine, le type de traduction et les exigences officielles.' },
        { title: 'Analyse de la demande', desc: 'L\'administrateur analyse la demande et le système recherche les professionnels compatibles.' },
        { title: 'Recevez votre devis', desc: 'Le devis est préparé selon votre document et les prestations demandées.' },
        { title: 'Validation et paiement', desc: 'Vous acceptez le devis puis procédez au paiement.' },
        { title: 'Traduction et vérification', desc: 'Le traducteur réalise le travail. Une vérification par un avocat ou un notaire peut être ajoutée si nécessaire.' },
        { title: 'Livraison', desc: 'Le document final est contrôlé puis livré dans votre espace client.' },
      ],
      finalTitle: 'Vous avez un document à traduire ?',
      finalText: 'Déposez votre document et laissez-nous identifier la prestation et le professionnel adaptés à votre besoin.',
      finalOrder: 'Commander en ligne',
      finalContact: 'Demander des informations',
      discover: 'Découvrir',
    },
    serviceTypes: {
      hubTitle: "Nos services de traduction",
      hubSubtitle: "Choisissez le domaine qui correspond à votre document",
      choiceTitle: "De quoi avez-vous besoin ?",
      choiceIntro: "Traductions officielles (avec cachet) et traductions par domaine (sans cachet administratif).",
      officialBadge: "1",
      officialTitle: "Traduction officielle (avec cachet)",
      officialIntro: "Pour une administration, un tribunal, une ambassade ou une université.",
      domainsBadge: "2",
      domainsTitle: "Traduction par domaine",
      domainsIntro: "Pour votre entreprise, votre site ou un usage courant.",
      seeServices: "Voir les services",
      wantThisService: "Commander en ligne",
      wantThisServiceLead: "Prêt à commander ? Accédez aux tarifs et documents de cette catégorie.",
      backToChoice: "Tous les domaines",
      catalogLabel: "Services de cette catégorie",
      page: {
        breadcrumbHome: "Accueil",
        breadcrumbServices: "Services",
        quoteBadge: "Devis en 30 min",
        quoteCta: "Demander un devis",
        quoteCardTitle: "Demander un devis",
        quoteCardText: "Envoyez-nous votre document : vous recevez un prix et un délai fermes en moins de 30 minutes ouvrées.",
        quoteCardNote: "Sans engagement",
        docsTitle: "Ce que nous prenons en charge",
        seeAllServices: "Voir tous les services",
        introText:
          "Chez Tarjemlek, ce service est confié à des professionnels agréés qui connaissent les exigences des administrations, des entreprises et des institutions. Chaque dossier est traité individuellement, relu, puis livré dans le délai annoncé.",
        introSubTitle: "Pourquoi faire appel à un professionnel ?",
        introSubText:
          "Un rendu approximatif ne se limite pas à une maladresse de style : il peut entraîner le rejet d'un dossier, un retard de procédure ou un malentendu lourd de conséquences. Faire appel à un professionnel, c'est l'assurance d'un résultat fidèle, conforme et accepté par votre destinataire.",
        whyTitle: "Pourquoi confier ce service à Tarjemlek ?",
        why: [
          {
            title: "Expertise du domaine",
            text: "Chaque dossier est confié à un traducteur qui maîtrise réellement le sujet et sa terminologie.",
          },
          {
            title: "Fidélité et précision",
            text: "Respect strict du document source, des termes techniques et de la mise en forme d'origine.",
          },
          {
            title: "Confidentialité garantie",
            text: "Vos fichiers circulent sur une connexion sécurisée et restent couverts par le secret professionnel.",
          },
          {
            title: "Respect des délais",
            text: "Le délai est confirmé avant le démarrage. Livraison sous 48 h, ou 24 h en express.",
          },
        ],
        whyClosing:
          "Confiez ce service à nos spécialistes et abordez vos démarches, en Tunisie comme à l'étranger, en toute sérénité.",
        inlineCta: "Contactez-nous dès aujourd'hui pour un devis personnalisé !",
        guaranteesTitle: "Nos garanties",
        guarantees: ["Réactivité", "Qualité optimale", "Confidentialité absolue", "Traducteurs agréés"],
        finalTitle: "Contactez notre équipe",
        finalText: "Parlez-nous de votre projet : nous vous guidons vers la solution adaptée et vous répondons rapidement.",
        contactCta: "Nous contacter",
      },
      types: {
        official: {
          title: "Traduction officielle",
          cardDesc: "Assermentée, certifiée, légalisation, apostille.",
          pageTitle: "Traduction officielle",
          pageLead: "Documents destinés aux administrations, tribunaux et organismes officiels — avec valeur légale (cachet et signature du traducteur agréé).",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Traduction assermentée", "Traduction certifiée", "Légalisation de traduction", "Apostille de documents"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Assermentée ou certifiée ?", a: "L'assermentée est réalisée par un traducteur assermenté pour les autorités nationales ; la certifiée porte un cachet et un numéro, souvent pour l'international. En cas de doute, nous vous orientons selon le pays." },
          ],
        },
        sworn: {
          title: "Traduction assermentée",
          cardDesc: "Traducteur assermenté agréé près des tribunaux, sceau et signature.",
          whenHint: "Si l'administration ou le tribunal exige un traducteur assermenté.",
          pageTitle: "Traduction assermentée",
          pageLead: "La traduction assermentée a une valeur juridique et reproduit le texte source sans modification.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Actes d'état civil", "Jugements et décisions", "Actes notariés", "Casier judiciaire", "Documents pour tribunaux et administrations"],
            },
          ],
        },
        certified: {
          title: "Traduction certifiée",
          cardDesc: "Cachet, signature et numéro de traduction, acceptés à l'international.",
          whenHint: "Pour diplômes, dossiers internationaux, légalisation / apostille.",
          pageTitle: "Traduction certifiée",
          pageLead: "La traduction certifiée garantit l'authenticité de vos documents officiels.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Diplômes et relevés de notes", "Actes d'état civil", "Documents à légaliser ou apostiller", "Dossiers consulaires et d'immigration"],
            },
          ],
        },
        legalization: {
          title: "Légalisation de traduction",
          cardDesc: "Légalisation pour la reconnaissance officielle de votre traduction.",
          whenHint: "Quand l'administration exige une légalisation en plus de la traduction.",
          pageTitle: "Légalisation de traduction",
          pageLead: "La légalisation atteste l'authenticité de la signature et du cachet du traducteur auprès des autorités compétentes.",
          sections: [
            {
              title: "Services associés",
              list: ["Légalisation de traduction", "Copie certifiée conforme", "Réédition de traduction", "Apostille de documents"],
            },
          ],
        },
        apostille: {
          title: "Apostille de documents",
          cardDesc: "Apostille Convention de La Haye pour la reconnaissance internationale.",
          whenHint: "Pour les pays signataires de la Convention de La Haye.",
          pageTitle: "Apostille de documents",
          pageLead: "L'apostille simplifie la reconnaissance d'un document officiel à l'étranger, sans légalisation consulaire complète.",
          sections: [
            {
              title: "Services associés",
              list: ["Apostille de documents", "Légalisation de traduction", "Traduction certifiée", "Traduction assermentée"],
            },
          ],
        },
        professional: {
          title: "Traduction professionnelle",
          cardDesc: "Traduction de qualité sans cachet officiel.",
          pageTitle: "Traduction professionnelle",
          pageLead: "Pour un usage courant ou professionnel, sans formalisme administratif.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Contenus d'entreprise", "Sites et applications", "Marketing et communication", "Documents techniques et commerciaux"],
            },
          ],
        },
        legal: {
          title: "Traduction juridique",
          cardDesc: "Contrats, jugements, actes notariés, brevets…",
          pageTitle: "Traduction juridique",
          pageLead: "Documents liés au droit, traduits avec une terminologie juridique précise.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Contrats", "Jugements", "Actes notariés", "Statuts d'entreprise", "Conditions générales de vente (CGV)", "Procurations", "Accords de confidentialité (NDA)", "Brevets", "Marques déposées", "Documents d'immigration"],
            },
          ],
        },
        technical: {
          title: "Traduction technique",
          cardDesc: "Manuels, notices, cahiers des charges…",
          pageTitle: "Traduction technique",
          pageLead: "Documents spécialisés dans l'industrie et la technologie, avec terminologie exacte.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Manuels d'utilisation", "Notices techniques", "Documentation industrielle", "Cahiers des charges", "Documentation automobile", "Documentation aéronautique", "Documentation électronique", "Documentation énergétique", "Documentation mécanique"],
            },
          ],
        },
        medical: {
          title: "Traduction médicale",
          cardDesc: "Rapports, ordonnances, essais cliniques…",
          pageTitle: "Traduction médicale",
          pageLead: "Documents du secteur médical et pharmaceutique, terminologie soignée.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Rapports médicaux", "Ordonnances", "Analyses médicales", "Dossiers patients", "Essais cliniques", "Notices pharmaceutiques", "Dispositifs médicaux", "Protocoles de recherche"],
            },
          ],
        },
        financial: {
          title: "Traduction financière",
          cardDesc: "Bilans, rapports annuels, audits…",
          pageTitle: "Traduction financière",
          pageLead: "Documents économiques et financiers.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Bilans comptables", "Rapports annuels", "États financiers", "Rapports d'audit", "Documents bancaires", "Assurances", "Fiscalité", "Prospectus financiers"],
            },
          ],
        },
        commercial: {
          title: "Traduction commerciale",
          cardDesc: "Catalogues, brochures, appels d'offres…",
          pageTitle: "Traduction commerciale",
          pageLead: "Documents liés aux entreprises et aux échanges commerciaux.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Catalogues", "Brochures", "Présentations commerciales", "Correspondances", "Appels d'offres", "Offres de prix", "Rapports commerciaux", "Documents RH"],
            },
          ],
        },
        marketing: {
          title: "Traduction marketing",
          cardDesc: "Campagnes, slogans, réseaux sociaux…",
          pageTitle: "Traduction marketing",
          pageLead: "Communication et publicité adaptées à votre marché cible.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Campagnes publicitaires", "Slogans", "Newsletters", "Réseaux sociaux", "Communiqués de presse", "Plaquettes commerciales", "Email marketing", "Branding"],
            },
          ],
        },
        it: {
          title: "Traduction informatique",
          cardDesc: "Logiciels, API, applications mobiles…",
          pageTitle: "Traduction informatique",
          pageLead: "Documents du domaine informatique et numérique.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Documentation logicielle", "Documentation API", "Guides utilisateurs", "Interfaces utilisateur", "Logiciels", "Jeux vidéo", "Applications mobiles", "Documentation cloud"],
            },
          ],
        },
        scientific: {
          title: "Traduction scientifique",
          cardDesc: "Articles, thèses, publications…",
          pageTitle: "Traduction scientifique",
          pageLead: "Documents de recherche et publications scientifiques.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Articles scientifiques", "Publications", "Thèses", "Mémoires", "Rapports de laboratoire", "Revues scientifiques"],
            },
          ],
        },
        digital: {
          title: "Traduction digitale",
          cardDesc: "Sites web, localisation, SEO, e-commerce…",
          pageTitle: "Traduction digitale",
          pageLead: "Services liés au web : traduction et localisation de vos plateformes.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Traduction de site Internet", "Localisation de site web", "Localisation d'application", "Localisation de logiciel", "Traduction SEO", "Traduction e-commerce", "Traduction UX/UI"],
            },
          ],
        },
        website: {
          title: "Traduction de site Internet",
          cardDesc: "Sites vitrines, e-commerce et applications.",
          pageTitle: "Traduction de site Internet",
          pageLead: "Adaptation de vos contenus web à la langue et à la culture de votre audience.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Sites vitrines", "Boutiques e-commerce", "Applications web", "Contenus et fiches produits"],
            },
          ],
        },
        audiovisual: {
          title: "Traduction audiovisuelle",
          cardDesc: "Sous-titrage, doublage, voice-over…",
          pageTitle: "Traduction audiovisuelle",
          pageLead: "Médias et vidéo : sous-titrage, doublage et transcription.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Sous-titrage", "Doublage", "Voice-over", "Transcription", "Adaptation de scénarios", "Sous-titrage multilingue"],
            },
          ],
        },
        tourism: {
          title: "Traduction touristique",
          cardDesc: "Guides, menus, sites d'hôtels…",
          pageTitle: "Traduction touristique",
          pageLead: "Secteur du tourisme et de l'hôtellerie, ton clair et attractif.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Guides touristiques", "Brochures", "Menus", "Sites d'hôtels", "Agences de voyages", "Applications touristiques"],
            },
          ],
        },
        luxury: {
          title: "Traduction luxe",
          cardDesc: "Joaillerie, horlogerie, mode, parfums…",
          pageTitle: "Traduction luxe",
          pageLead: "Secteurs haut de gamme : chaque mot respecte l'image de la marque.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Joaillerie", "Horlogerie", "Mode", "Parfums", "Cosmétique", "Hôtellerie de luxe"],
            },
          ],
        },
        interpreting: {
          title: "Interprétariat",
          cardDesc: "Conférence, professionnel et à distance.",
          pageTitle: "Interprétariat",
          pageLead: "Interprètes pour vos réunions, rendez-vous et événements — en présentiel ou à distance.",
          sections: [
            {
              title: "Documents pris en charge",
              list: ["Interprétation simultanée", "Interprétation consécutive", "Interprétation de liaison", "Interprétation judiciaire", "Interprétation médicale", "Interprétation téléphonique", "Interprétation en visioconférence"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Comment réserver ?", a: "Indiquez la date, la durée, les langues et le mode. Nous confirmons le tarif et le profil adapté." },
          ],
        },
        simultaneous: {
          title: "Interprétation simultanée",
          cardDesc: "En temps réel, en cabine ou avec matériel mobile.",
          pageTitle: "Interprétation simultanée",
          pageLead: "L'interprète traduit en temps réel pendant que l'orateur parle. La solution des conférences et des grands événements multilingues.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Conférences et congrès", "Séminaires et forums internationaux", "Assemblées générales", "Formations multilingues", "Événements diffusés en direct"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["Nous mobilisons deux interprètes par langue et par demi-journée, car l'exercice demande une concentration soutenue. Le matériel (cabine, casques, récepteurs) peut être fourni sur demande."],
              list: ["Deux interprètes par combinaison de langues", "Cabine insonorisée ou système portatif", "Documents préparatoires étudiés en amont"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Faut-il du matériel ?", a: "Oui, une cabine ou un système portatif avec casques. Nous pouvons l'inclure dans le devis ou travailler avec le prestataire de votre salle." },
            { q: "Pourquoi deux interprètes ?", a: "La simultanée exige une attention extrême. Les interprètes se relaient toutes les 20 à 30 minutes pour garantir la qualité sur toute la durée." },
            { q: "Combien de temps à l'avance réserver ?", a: "Idéalement 2 à 3 semaines pour un événement, afin de réunir les bons profils et le matériel. Les demandes urgentes restent possibles selon disponibilité." },
          ],
        },
        consecutive: {
          title: "Interprétation consécutive",
          cardDesc: "L'interprète traduit après chaque prise de parole.",
          pageTitle: "Interprétation consécutive",
          pageLead: "L'orateur parle, puis l'interprète restitue son propos. Aucun matériel nécessaire — idéal pour les réunions et interventions courtes.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Réunions de travail et négociations", "Discours et cérémonies", "Visites d'entreprise et d'usine", "Conférences de presse", "Points techniques en petit comité"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["L'interprète prend des notes pendant l'intervention, puis restitue le message avec précision. Prévoyez environ le double du temps de parole."],
              list: ["Aucun équipement requis", "Un interprète suffit dans la plupart des cas", "Terminologie préparée à partir de vos documents"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Consécutive ou simultanée ?", a: "La consécutive convient aux réunions de moins de 20 personnes et aux échanges courts. Au-delà, ou si le temps est compté, la simultanée est préférable." },
            { q: "Cela double-t-il la durée de la réunion ?", a: "Presque : chaque intervention est prononcée deux fois. Nous en tenons compte dans l'estimation du temps et du tarif." },
          ],
        },
        liaison: {
          title: "Interprétation de liaison",
          cardDesc: "Accompagnement en tête-à-tête ou en petit groupe.",
          pageTitle: "Interprétation de liaison",
          pageLead: "Un interprète vous accompagne dans vos démarches et échanges en petit comité, en passant d'une langue à l'autre au fil de la conversation.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Rendez-vous administratifs et consulaires", "Signatures chez le notaire", "Visites de sites et salons professionnels", "Entretiens d'embauche", "Accompagnement de délégations"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["L'interprète reste à vos côtés pendant toute la durée du rendez-vous et traduit dans les deux sens, phrase par phrase. Discrétion et neutralité sont la règle."],
              list: ["Facturation à l'heure ou à la demi-journée", "Déplacements possibles en Tunisie et à l'étranger", "Confidentialité garantie"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "L'interprète peut-il se déplacer ?", a: "Oui, partout en Tunisie et à l'étranger. Les frais de déplacement sont indiqués dans le devis avant confirmation." },
            { q: "Quelle est la durée minimum ?", a: "Deux heures en général. Au-delà de quatre heures, le tarif demi-journée s'applique." },
          ],
        },
        judicial: {
          title: "Interprétation judiciaire",
          cardDesc: "Tribunaux, auditions et actes notariés.",
          pageTitle: "Interprétation judiciaire",
          pageLead: "Interprètes assermentés pour les audiences, auditions et actes officiels, où chaque mot engage une responsabilité juridique.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Audiences et procès", "Auditions et dépositions", "Actes notariés et signatures d'actes", "Procédures d'immigration et d'asile", "Interrogatoires et enquêtes"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["Seuls des interprètes assermentés, agréés par les tribunaux, interviennent sur ces missions. Ils maîtrisent la terminologie de procédure et sont tenus au secret professionnel."],
              list: ["Interprètes agréés par les tribunaux tunisiens", "Restitution fidèle, sans interprétation ni ajout", "Secret professionnel absolu"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "L'interprète est-il assermenté ?", a: "Oui. Pour toute procédure judiciaire, nous mandatons exclusivement des interprètes assermentés reconnus par les tribunaux." },
            { q: "Pouvez-vous intervenir en urgence ?", a: "Nous traitons les convocations urgentes selon disponibilité. Contactez-nous dès réception de la date d'audience." },
          ],
        },
        phone: {
          title: "Interprétation téléphonique",
          cardDesc: "Un interprète en ligne, en quelques minutes.",
          pageTitle: "Interprétation téléphonique",
          pageLead: "Un interprète vous rejoint par téléphone pour vos appels et démarches à distance, sans déplacement ni installation.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Appels avec une administration étrangère", "Échanges avec une banque ou un assureur", "Prise de rendez-vous médicaux à l'étranger", "Suivi de dossier consulaire", "Besoins urgents et ponctuels"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["Vous indiquez la langue et le créneau souhaité. L'interprète rejoint l'appel en conférence à trois et traduit en direct."],
              list: ["Facturation à la minute ou par tranche de 15 minutes", "Mise en relation rapide selon la langue", "Aucun matériel ni logiciel à installer"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Dans quel délai un interprète est-il disponible ?", a: "Pour les langues courantes, souvent le jour même. Pour les langues rares, prévoyez 24 à 48 heures." },
            { q: "Comment se déroule l'appel ?", a: "Nous organisons une conférence à trois : vous, votre interlocuteur et l'interprète. Aucune installation n'est nécessaire de votre côté." },
          ],
        },
        video: {
          title: "Interprétation en visioconférence",
          cardDesc: "Zoom, Teams, Meet — à distance et multilingue.",
          pageTitle: "Interprétation en visioconférence",
          pageLead: "Vos réunions en ligne deviennent multilingues : l'interprète rejoint votre visioconférence et traduit en direct.",
          sections: [
            {
              title: "Quand la choisir",
              list: ["Réunions d'équipes internationales", "Webinaires et présentations en ligne", "Entretiens et soutenances à distance", "Comités de direction multilingues", "Rendez-vous consulaires en visio"],
            },
            {
              title: "Comment nous travaillons",
              paragraphs: ["Nous intervenons sur Zoom, Teams, Google Meet et les principales plateformes. En mode simultané, nous utilisons les canaux de langue quand la plateforme les propose."],
              list: ["Compatible Zoom, Teams, Google Meet, Webex", "Mode simultané ou consécutif selon le format", "Test technique avant la réunion"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Quelles plateformes prenez-vous en charge ?", a: "Zoom, Microsoft Teams, Google Meet, Webex et la plupart des outils de visioconférence. Précisez le vôtre lors de la réservation." },
            { q: "Faut-il une licence particulière ?", a: "Pour la simultanée avec canaux de langue séparés, Zoom requiert une licence compatible. Sinon, nous travaillons en consécutif, sans contrainte technique." },
          ],
        },
        transcription: {
          title: "Transcription et retranscription",
          cardDesc: "Vos fichiers audio et vidéo mis à l'écrit.",
          pageTitle: "Transcription et retranscription",
          pageLead: "Nous transformons vos enregistrements audio et vidéo en documents écrits fidèles, dans la langue d'origine ou traduits.",
          sections: [
            {
              title: "Ce que nous transcrivons",
              list: ["Réunions, comités et assemblées", "Entretiens et interviews", "Conférences et formations", "Audiences et dépositions", "Podcasts et contenus vidéo", "Enquêtes et études qualitatives"],
            },
            {
              title: "Nos formats de rendu",
              paragraphs: ["Vous choisissez le niveau de finition selon l'usage : verbatim intégral pour un usage juridique, ou version épurée et lisible pour une diffusion."],
              list: ["Verbatim intégral (mot à mot, hésitations incluses)", "Version épurée et relue", "Horodatage et identification des intervenants", "Livraison en Word, PDF ou fichier de sous-titres"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Quelle est la différence entre transcription et retranscription ?", a: "La transcription met à l'écrit un enregistrement dans sa langue d'origine. La retranscription y ajoute la traduction vers une autre langue." },
            { q: "Comment est calculé le tarif ?", a: "À la durée de l'enregistrement, selon la qualité audio, le nombre d'intervenants et le niveau de finition demandé." },
            { q: "Et si l'audio est de mauvaise qualité ?", a: "Nous l'écoutons avant de confirmer le devis. Les passages réellement inaudibles sont signalés dans le document plutôt que devinés." },
          ],
        },
        voiceover: {
          title: "Voice-over",
          cardDesc: "Voix off professionnelle, doublage et sous-titrage.",
          pageTitle: "Voice-over",
          pageLead: "Nous prêtons une voix à vos contenus dans la langue de votre public : traduction du script, enregistrement et synchronisation.",
          sections: [
            {
              title: "Ce que nous produisons",
              list: ["Vidéos institutionnelles et corporate", "Modules e-learning et tutoriels", "Publicités et spots radio", "Documentaires et reportages", "Messages d'accueil téléphonique", "Sous-titrage multilingue"],
            },
            {
              title: "Notre processus",
              paragraphs: ["Le script est d'abord traduit et adapté à la durée des séquences, puis enregistré par un comédien voix natif et enfin synchronisé sur votre vidéo."],
              list: ["Traduction et adaptation du script au minutage", "Voix natives, hommes et femmes, plusieurs tonalités", "Enregistrement en studio", "Mixage et synchronisation sur votre montage"],
            },
          ],
          faqTitle: "Questions fréquentes",
          faq: [
            { q: "Peut-on choisir la voix ?", a: "Oui. Nous vous envoyons des échantillons de voix disponibles dans la langue cible et vous validez avant l'enregistrement." },
            { q: "Voice-over ou doublage ?", a: "Le voice-over superpose une voix narrative à la bande d'origine. Le doublage remplace les dialogues en synchronisant le mouvement des lèvres. Nous proposons les deux." },
            { q: "Fournissez-vous aussi les sous-titres ?", a: "Oui, en fichier SRT ou VTT, ou incrustés directement dans la vidéo." },
          ],
        },
        general: { title: "Traduction générale", cardDesc: "Traduction de documents courants, personnels et administratifs." },
        specialized: { title: "Traduction spécialisée", cardDesc: "Juridique, technique, médicale, financière et commerciale." },
        personal: { title: "Documents personnels", cardDesc: "Actes d'état civil, passeports, cartes d'identité et certificats." },
        administrative: { title: "Documents administratifs", cardDesc: "Permis, casiers, justificatifs et attestations diverses." },
        academic: { title: "Diplômes & certificats", cardDesc: "Traduction de diplômes, relevés de notes et attestations scolaires." },
        legalDocs: { title: "Documents juridiques", cardDesc: "Contrats, jugements, actes notariés et procurations." },
        commercialDocs: { title: "Documents commerciaux", cardDesc: "Catalogues, brochures, appels d'offres et rapports d'entreprise." },
        medicalDocs: { title: "Documents médicaux", cardDesc: "Rapports, ordonnances, analyses et comptes rendus de santé." },
        medicalInterpreting: { title: "Interprétariat médical", cardDesc: "Accompagnement pour consultations et dossiers de santé." },
        businessInterpreting: { title: "Interprétariat en entreprise", cardDesc: "Réunions, négociations et événements professionnels." },
        remoteInterpreting: { title: "Interprétariat à distance", cardDesc: "Par téléphone ou visioconférence, partout dans le monde." },
      },
    },
    translators: translatorsFr,
    quoteWizard: quoteWizardFr,
    quoteForm: quoteFormFr,
    dashboard: dashboardFr,
    why: {
      title: 'Pourquoi choisir Tarjemlek ?',
      quality: 'Qualité certifiée',
      qualityDesc: 'Traducteurs assermentés agréés par les tribunaux tunisiens.',
      speed: 'Livraison rapide',
      speedDesc: 'PDF certifié sous 48h, option express 24h disponible.',
      price: 'Prix transparents',
      priceDesc: 'Devis instantané, sans frais cachés. Paiement sécurisé.',
      support: 'Support multilingue',
      supportDesc: 'Assistance en français, arabe et anglais, 7j/7.',
      guarantee: 'Garantie zéro rejet',
      guaranteeDesc: 'Documents retraduits gratuitement si refusés par une autorité officielle.',
      digital: 'PDF certifié + originaux',
      digitalDesc: 'Traduction numérique par email ou espace client. Envoi des originaux papier lorsque requis par l\'administration.',
    },
    whyChoose: {
      kicker: 'Tarjemlek',
      title: 'Pourquoi nous choisir',
      intro:
        'Documents officiels, contenus d\'entreprise ou dossiers spécialisés : Tarjemlek confie chaque projet au traducteur qui maîtrise réellement le sujet.',
      cta: 'Découvrir tous nos services',
      learnMore: 'Voir ce service',
      commitmentsTitle: 'Nos engagements',
      services: [
        {
          title: 'Traduction assermentée',
          text: 'Vos actes d\'état civil, diplômes et documents administratifs traduits avec le cachet et la signature d\'un traducteur agréé.',
        },
        {
          title: 'Traduction de sites internet',
          text: 'Sites vitrines, boutiques en ligne et applications adaptés à votre marché, sans perdre le sens ni le ton de votre marque.',
        },
        {
          title: 'Traduction technique',
          text: 'Manuels, notices, cahiers des charges et fiches produits traduits avec une terminologie cohérente d\'un document à l\'autre.',
        },
        {
          title: 'Traduction juridique',
          text: 'Contrats, jugements, statuts et actes notariés pris en charge par des traducteurs formés au droit tunisien et international.',
        },
        {
          title: 'Traduction médicale',
          text: 'Certificats, comptes rendus, analyses et dossiers de soins traduits avec rigueur et strictement confidentiels.',
        },
        {
          title: 'Traduction certifiée',
          text: 'Traductions conformes à l\'original, acceptées par les administrations, ambassades, universités et entreprises.',
        },
      ],
      items: [
        {
          title: 'Qualité',
          text: 'Chaque traduction est réalisée par un traducteur assermenté agréé par les tribunaux tunisiens, puis relue avant l\'envoi.',
        },
        {
          title: 'Confidentialité',
          text: 'Vos fichiers circulent sur une connexion sécurisée, restent couverts par le secret professionnel et ne sont jamais partagés.',
        },
        {
          title: 'Délais',
          text: 'Livraison en PDF sous 48h, ou 24h en express. Le délai est confirmé avant que la traduction ne démarre.',
        },
        {
          title: 'Tarifs',
          text: 'Le prix annoncé couvre la traduction, la relecture, la livraison et les corrections. Aucun supplément après commande.',
        },
        {
          title: 'Support 24/7',
          text: 'Contactez-nous à tout moment via chat, email, SMS, téléphone ou WhatsApp. Une réponse rapide, quel que soit votre fuseau horaire.',
        },
      ],
    },
    trust: {
      title: 'Votre confiance, notre engagement',
      subtitle: 'Un réseau de professionnels agréés au service des Tunisiens de l\'étranger et du bassin méditerranéen',
      sworn: 'Traducteurs assermentés',
      swornDesc: 'Agréés par les tribunaux tunisiens — acceptés par les administrations.',
      guarantee: 'Garantie zéro rejet',
      guaranteeDesc: 'Retraduction gratuite si votre document est refusé par une autorité.',
      pricing: 'Prix transparents',
      pricingDesc: 'Devis instantané affiché avant inscription — aucun frais caché.',
      digital: 'Livraison flexible',
      digitalDesc: 'PDF certifié sous 48h — originaux papier envoyés par courrier lorsque nécessaire.',
      whatsapp: 'WhatsApp 24/7',
      whatsappDesc: 'Support instantané pour demandes urgentes et suivi de dossier.',
      secure: 'Paiement sécurisé',
      secureDesc: 'Carte bancaire, virement ou mobile payment — facture automatique.',
    },
    useCases: {
      title: 'Pour toutes vos démarches',
      subtitle: 'Ambassades, visas, universités, diplômes et procédures administratives à l\'étranger',
      visa: 'Visa & titre de séjour',
      visaDesc: 'Dossiers consulaires, certificats médicaux, attestations de ressources.',
      immigration: 'Immigration & naturalisation',
      immigrationDesc: 'Casier judiciaire, actes d\'état civil, dossiers de regroupement familial.',
      studies: 'Études & équivalence',
      studiesDesc: 'Diplômes, relevés de notes, thèses pour inscription universitaire.',
      marriageAbroad: 'Mariage à l\'étranger',
      marriageAbroadDesc: 'Actes de naissance, certificats de célibat, traductions notariées.',
      business: 'Création d\'entreprise',
      businessDesc: 'Statuts, contrats commerciaux, documents d\'immatriculation.',
      legal: 'Procédures judiciaires',
      legalDesc: 'Jugements, procurations, contrats et pièces pour tribunaux.',
    },
    pricing: {
      title: 'Tarifs transparents',
      subtitle: 'Prix affichés publiquement — devis instantané sans inscription',
      perPage: 'TND / page',
      from: 'À partir de',
      standard: 'Standard',
      express: 'Express',
      urgent: 'Urgent',
      standardDelay: '4-5 jours',
      expressDelay: '48h',
      urgentDelay: '24h',
      note: 'Majoration express ×1,5 — urgent ×2. Apostille 10–15 TND/doc. (tarif officiel). Équivalent EUR indicatif pour l\'étranger.',
      cta: 'Calculer mon devis',
    },
    qa: {
      title: 'Notre processus de contrôle qualité',
      subtitle: 'Transparence totale à chaque étape — de la réception à la livraison',
      step1: 'Évaluation du fichier',
      step1Desc: 'Vérification de la lisibilité, complétude et adéquation du document source.',
      step2: 'Traduction par expert',
      step2Desc: 'Traducteur assermenté spécialisé dans le domaine du document.',
      step3: 'Relecture native',
      step3Desc: 'Contrôle linguistique et terminologique par un relecteur qualifié.',
      step4: 'Certification officielle',
      step4Desc: 'Apposition du cachet, signature et mention légale du traducteur assermenté.',
      step5: 'Livraison sécurisée',
      step5Desc: 'PDF certifié par email ou espace client. Envoi des originaux papier par courrier lorsque l\'administration l\'exige.',
    },
    legal: {
      title: 'Mentions légales & conditions',
      refundTitle: 'Politique d\'annulation et de remboursement',
      refundText: 'Annulation gratuite avant le début de la traduction. Remboursement intégral si la commande est annulée dans les 2 heures suivant le paiement. Aucun remboursement après livraison du document certifié, sauf en cas de garantie zéro rejet activée.',
      termsTitle: 'Conditions générales de vente',
      termsText: 'Tarjemlek propose des traductions assermentées réalisées par des traducteurs agréés. Les délais indiqués sont des estimations en jours ouvrés. Le client est responsable de la qualité des scans fournis.',
      privacyTitle: 'Confidentialité',
      privacyText: 'Vos documents sont traités de manière strictement confidentielle et supprimés de nos serveurs 90 jours après livraison, sauf demande contraire.',
    },
    faq: {
      title: 'Questions fréquentes',
    },
    ecosystem: {
      title: 'Un écosystème de professionnels à votre service',
      subtitle: 'Traduction, apostille, conseil juridique et actes officiels — des offres packagées pour les Tunisiens de l\'étranger',
      translator: 'Traducteurs assermentés',
      translatorDesc: 'Traductions certifiées acceptées par les ambassades, universités et administrations.',
      notary: 'Notaires',
      notaryDesc: 'Apostille, légalisation et certification de vos actes pour l\'usage international.',
      lawyer: 'Avocats',
      lawyerDesc: 'Conseil juridique et accompagnement pour vos démarches à l\'étranger.',
      bailiff: 'Commissaires de justice',
      bailiffDesc: 'Significations, constats et procédures pour vos dossiers officiels.',
      note: 'Tarjemlek regroupe ces professionnels pour vous proposer des parcours simplifiés, depuis la Tunisie vers le monde entier.',
    },
    cta: {
      title: 'Prêt à traduire vos documents ?',
      subtitle: 'Obtenez un devis gratuit en moins de 60 minutes ouvrées.',
      button: 'Commander maintenant',
    },
    reviews: {
      title: 'Satisfaction client',
      subtitle: 'Des Tunisiens à l\'étranger et des institutions nous font confiance pour leurs dossiers officiels',
      score: '4.9',
      basedOn: 'Basé sur 340+ avis vérifiés',
      r1: {
        text: 'Traduction de mon acte de naissance livrée en 36h. Acceptée sans problème à l\'ambassade de Tunisie à Paris.',
        name: 'Sami B.',
        role: 'Tunisien résident, France',
        doc: 'Acte de naissance',
        category: 'Traduction assermentée',
        subcategory: 'État civil',
        from: 'Arabe',
        to: 'Français',
      },
      r2: {
        text: 'J\'ai fait traduire mon diplôme pour l\'inscription à l\'université en Allemagne. Processus simple, prix clair.',
        name: 'Ines M.',
        role: 'Tunisienne étudiante, Allemagne',
        doc: 'Diplôme universitaire',
        category: 'Traduction assermentée',
        subcategory: 'Scolaire & universitaire',
        from: 'Français',
        to: 'Allemand',
      },
      r3: {
        text: 'Excellent support pour mon dossier de visa. Traduction + apostille en une seule démarche.',
        name: 'Karim H.',
        role: 'Tunisien résident, Canada',
        doc: 'Casier judiciaire',
        category: 'Traduction + apostille',
        subcategory: 'Judiciaire',
        from: 'Arabe',
        to: 'Français',
      },
      r4: {
        text: 'Notre entreprise méditerranéenne utilise Tarjemlek pour tous nos documents officiels. Fiable et rapide.',
        name: 'Laura P.',
        role: 'Responsable RH, Italie',
        doc: 'Contrat commercial',
        category: 'Traduction commerciale',
        subcategory: 'Entreprise',
        from: 'Français',
        to: 'Italien',
      },
      r5: {
        text: 'Bonne expérience pour la procuration de mes parents restés en Tunisie. Tout a été accepté à l\'étranger.',
        name: 'Amira T.',
        role: 'Tunisienne résidente, Belgique',
        doc: 'Procuration',
      },
      r6: {
        text: 'Ma traduction de certificat de mariage a été acceptée au consulat sans aucun problème. Je recommande.',
        name: 'Youssef K.',
        role: 'Tunisien résident, Suisse',
        doc: 'Acte de mariage',
      },
    },
    footer: {
      description:
        'Tarjemlek accompagne les Tunisiens résidant à l\'étranger et les institutions méditerranéennes pour leurs démarches documentaires officielles.',
      services: 'Services',
      company: 'Entreprise',
      legal: 'Mentions légales',
      privacy: 'Confidentialité',
      rights: 'Tous droits réservés.',
      address: 'Tunis, Tunisie',
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Notre équipe vous répond sous 60 minutes en jours ouvrés.',
      civility: 'Civilité',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      message: 'Votre message',
      send: 'Envoyer',
      success: 'Message envoyé ! Nous vous répondrons rapidement.',
      badge: 'Nous sommes à votre écoute',
      breadcrumbHome: 'Accueil',
      infoTitle: 'Coordonnées',
      formTitle: 'Écrivez-nous',
      formHint: 'Décrivez votre besoin, nous revenons vers vous rapidement.',
      phoneLabel: 'Téléphone',
      emailLabel: 'E-mail',
      addressLabel: 'Adresse',
      hoursLabel: 'Horaires',
      hoursValue: 'Lun – Sam · 8h00 – 20h00',
      whatsapp: 'Discuter sur WhatsApp',
      successAgain: 'Envoyer un autre message',
      optional: 'optionnel',
      messagePlaceholder: 'Documents à traduire, langues souhaitées, délai…',
    },
    order: {
      title: 'Commander une traduction',
      subtitle: 'Choisissez votre document, les langues et finalisez en quelques étapes.',
      step: 'Étape',
      of: 'sur',
      stepDoc: 'Document',
      stepFiles: 'Fichiers',
      stepSummary: 'Confirmation',
      chooseDoc: 'Choisir un type de document',
      chooseLang: 'Choisir une paire de langues',
      allCategories: 'Tous',
      searchDocs: 'Rechercher un document…',
      noDocs: 'Aucun document trouvé.',
      perPage: '/ page',
      yes: 'Oui',
      no: 'Non',
      stepDocHint: 'Sélectionnez le document, puis vos options de traduction.',
      stepFilesHint: 'Ajoutez vos fichiers et précisions utiles.',
      stepSummaryHint: 'Vérifiez le récapitulatif avant de confirmer.',
      deliveryDigitalShort: 'PDF par email',
      deliveryPhysicalShort: 'Papier + PDF (+15 TND)',
      docType: 'Type de document',
      langPair: 'Paire de langues',
      pages: 'Nombre de pages',
      urgency: 'Délai souhaité',
      standard: 'Standard (4-5 jours)',
      express: 'Express (48h)',
      urgent: 'Urgent (24h)',
      upload: 'Téléverser vos documents',
      uploadHint: 'PDF, JPG, PNG — max 10 Mo par fichier',
      dragDrop: 'Glissez vos fichiers ici ou cliquez pour parcourir',
      info: 'Informations complémentaires',
      infoPlaceholder: 'Pays de destination, procédure particulière, légalisation...',
      next: 'Suivant',
      prev: 'Précédent',
      submit: 'Confirmer la commande',
      summary: 'Récapitulatif',
      estimated: 'Estimation',
      delivery: 'Mode de livraison',
      deliveryDigital: 'Numérique (PDF certifié par email)',
      deliveryPhysical: 'Papier + numérique — originaux si requis (+15 TND)',
      apostille: 'Apostille / légalisation',
      apostilleAdd: 'Ajouter apostille (10–15 TND / doc., tarif officiel)',
      apostilleRange: '10–15 TND / doc. (tarif officiel)',
      eurNote: 'Montants en euros indicatifs pour les clients à l\'étranger.',
      successTitle: 'Commande confirmée !',
      successText: 'Nous examinerons vos documents et vous enverrons une confirmation par email sous 60 minutes.',
      backHome: 'Retour à l\'accueil',
      selectDoc: 'Sélectionnez un document pour voir l\'estimation',
      files: 'Fichiers',
      fileUnit: 'fichier(s)',
      loginBanner: 'Connectez-vous pour confirmer votre commande et recevoir vos traductions dans votre espace client.',
      loginToSubmit: 'Se connecter pour confirmer',
    },
    auth: {
      loginTitle: 'Connexion',
      loginSubtitle: 'Accédez à votre espace Tarjemlek',
      registerTitle: 'Créer un compte',
      registerSubtitle: 'Un compte est requis pour commander et recevoir vos documents',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom complet',
      loginButton: 'Se connecter',
      registerButton: 'Créer mon compte',
      noAccount: 'Pas encore de compte ?',
      hasAccount: 'Déjà un compte ?',
      registerLink: 'S\'inscrire',
      loginLink: 'Se connecter',
      logout: 'Déconnexion',
      dashboard: 'Tableau de bord',
      myAccount: 'Mon compte',
      loginRequiredText: 'Vous pouvez préparer votre commande librement. Pour la confirmer, connectez-vous ou créez un compte.',
      invalidCredentials: 'Email ou mot de passe incorrect',
      emailNotFound: 'Cet email n\'existe pas dans notre base.',
      inactive: 'Votre compte est désactivé. Contactez l’administrateur.',
      currentPassword: 'Mot de passe actuel',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      changePassword: 'Changer le mot de passe',
      passwordChanged: 'Mot de passe mis à jour avec succès.',
      wrongPassword: 'Mot de passe actuel incorrect.',
      emailExists: 'Cet email est déjà utilisé',
      guestAccountExists: 'Vous avez déjà commandé avec cet email. Un email d\'activation de compte vient de vous être envoyé.',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordHint: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.',
      passwordReqMin: '8 caractères minimum',
      passwordReqUpper: 'Une majuscule',
      passwordReqLower: 'Une minuscule',
      passwordReqNumber: 'Un chiffre',
      passwordReqSpecial: 'Un caractère spécial',
      passwordsMismatch: 'Les mots de passe ne correspondent pas',
      invalidEmail: 'Adresse e-mail invalide',
      invalidPayload: 'Veuillez remplir tous les champs obligatoires',
      termsNotAccepted: 'Vous devez accepter les conditions générales d\'utilisation',
      organizationNameRequired: 'Le nom de l\'entreprise ou de l\'organisation est requis',
      registerSuccess: 'Votre inscription a été créée avec succès. Redirection…',
      welcomeBack: 'Connectez-vous',
      loginFormHint: 'Connectez-vous à votre espace.',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      perkSecure: 'Paiement et données sécurisés',
      perkOrders: 'Suivi de vos commandes en ligne',
      perkDocs: 'PDF certifiés prêts à télécharger',
      forgotLink: 'Mot de passe oublié ?',
      forgotTitle: 'Réinitialiser le mot de passe',
      forgotHint: 'Entrez votre email pour recevoir un lien de réinitialisation.',
      forgotButton: 'Envoyer le lien',
      forgotSent: 'Si un compte existe, un email contenant un lien de réinitialisation a été envoyé. Veuillez vérifier votre boîte de réception.',
      resetContinue: 'Continuer la réinitialisation',
      resetTitle: 'Nouveau mot de passe',
      resetHint: 'Choisissez un mot de passe d’au moins 6 caractères.',
      resetToken: 'Jeton',
      newPassword: 'Nouveau mot de passe',
      resetButton: 'Enregistrer',
      resetDone: 'Mot de passe mis à jour. Redirection…',
      invalidToken: 'Lien invalide ou expiré',
    },
    about: {
      title: 'À propos de Tarjemlek',
      subtitle: 'Votre plateforme de traduction et d’interprétariat professionnels',
      heroTagline: 'Traduction, interprétariat et services documentaires — simples, fiables et accessibles partout.',
      whoWeAreTitle: 'Qui sommes-nous ?',
      whoWeAreIntro: 'Tarjemlek est une plateforme tunisienne qui simplifie l’accès aux services documentaires et linguistiques pour les particuliers, les entreprises et les institutions.',
      mission: 'Rendre chaque démarche de traduction, certification et interprétariat simple, fiable et accessible, où que vous soyez.',
      vision: 'Devenir le pont linguistique et juridique de référence entre la Tunisie, l’Europe et le reste du monde.',
      values: 'Rigueur, confidentialité, réactivité et professionnalisme',
      positioning: 'Traduction et interprétariat professionnels',
      servicesTitle: 'Nos services',
      servicesIntro: 'Des solutions adaptées à chaque besoin, réalisées par des experts qualifiés.',
      professionalTranslation: 'Traduction professionnelle',
      officialTranslation: 'Traduction officielle',
      interpreting: 'Interprétariat',
      additionalServices: 'Services complémentaires',
      teamTitle: 'Notre équipe',
      teamIntro: 'Un réseau de professionnels expérimentés et reconnus dans leurs domaines.',
      translators: 'Traducteurs',
      interpreters: 'Interprètes',
      lawyers: 'Avocats',
      notaries: 'Notaires',
      processTitle: 'Notre processus',
      processIntro: 'Un parcours clair et transparent, de la demande à la livraison.',
      processSteps: [
        { title: 'Demande du client', desc: 'Vous déposez votre document ou décrivez votre besoin.' },
        { title: 'Analyse', desc: 'Nous évaluons le type de document, la langue et l’urgence.' },
        { title: 'Devis', desc: 'Vous recevez un prix et un délai clairs.' },
        { title: 'Paiement', desc: 'Règlement sécurisé en ligne.' },
        { title: 'Affectation', desc: 'Un professionnel qualifié prend en charge votre dossier.' },
        { title: 'Réalisation', desc: 'Traduction, révision et mise en forme selon les normes.' },
        { title: 'Vérification', desc: 'Contrôle qualité et certification si nécessaire.' },
        { title: 'Livraison', desc: 'Réception du document par email ou papier selon votre choix.' },
      ],
      whyTitle: 'Pourquoi nous choisir ?',
      whyIntro: 'Nous mettons l’expertise et l’organisation au service de chaque projet.',
      whyPoints: [
        { title: 'Traducteurs spécialisés', desc: 'Chaque dossier est confié à un expert du domaine.' },
        { title: 'Plusieurs langues', desc: 'Une couverture large pour vos besoins multilingues.' },
        { title: 'Expertise par domaine', desc: 'Juridique, médical, technique, commercial, académique.' },
        { title: 'Vérification professionnelle', desc: 'Relecture et contrôle qualité systématiques.' },
        { title: 'Suivi de commande', desc: 'Un interlocuteur dédié et un suivi à chaque étape.' },
        { title: 'Respect des délais', desc: 'Livraison dans les temps convenus, y compris en urgence.' },
        { title: 'Confidentialité', desc: 'Vos documents sont traités avec la plus grande sécurité.' },
      ],
      commitmentTitle: 'Notre engagement',
      commitmentIntro: 'Nous nous engageons sur des valeurs fortes pour vous garantir la sérénité.',
      commitments: [
        'Qualité',
        'Confidentialité',
        'Fiabilité',
        'Respect des délais',
        'Accompagnement du client',
      ],
      ctaTitle: 'Besoin d’une traduction ou d’un interprète ?',
      ctaText: 'Commandez en ligne ou contactez-nous pour un devis personnalisé.',
      orderButton: 'Commander en ligne',
      contactButton: 'Nous contacter',
    },
    translator: {
      title: 'Rejoignez notre réseau de traducteurs',
      subtitle: 'Plus de 100 traducteurs certifiés collaborent déjà avec Tarjemlek.',
      apply: 'Postuler maintenant',
      civility: 'Civilité',
      name: 'Nom complet',
      email: 'Email',
      langPairs: 'Paires de langues',
      langPairsHint: 'Ajoutez une ou plusieurs paires (langue source → langue cible).',
      fromLang: 'De',
      toLang: 'Vers',
      addPair: 'Ajouter',
      selectLang: 'Choisir',
      pairRequired: 'Ajoutez au moins une paire de langues.',
      specialization: 'Spécialisation',
      experience: 'Expérience (années)',
      cv: 'CV / Portfolio (PDF)',
      choose: '—',
      specialties: {
        legal: 'Juridique',
        medical: 'Médical',
        academic: 'Académique',
        commercial: 'Commercial',
        technical: 'Technique',
      },
      perk1: 'Projets internationaux variés',
      perk2: 'Rémunération compétitive',
      perk3: 'Réseau de 100+ traducteurs',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      translation: 'الترجمة',
      certifiedTranslation: 'ترجمة مصادق عليها',
      professionalTranslation: 'ترجمة احترافية',
      interpreting: 'الترجمة الفورية',
      documents: 'الوثائق',
      order: 'اطلب عبر الإنترنت',
      howItWorks: 'كيف نعمل',
      faq: 'أسئلة شائعة',
      about: 'من نحن',
      contact: 'اتصل بنا',
      translator: 'انضم كمترجم',
      translators: 'شبكتنا',
      orderNow: 'اطلب ترجمة',
      login: 'تسجيل الدخول',
      menu: 'القائمة',
      language: 'اللغة',
      topMessage: 'وثائقكم مترجمة ومعتمدة — PDF معتمد ونسخ أصلية عند الطلب ✦',
      viewAllServices: 'كل الترجمات',
      viewAllInterpreting: 'كل خدمات الترجمة الفورية',
      viewMore: 'عرض الكل',
      servicesCategoriesLabel: 'تخصصات الترجمة',
      servicesMenu: {
        specialtiesTitle: 'الخدمات',
        professionalGroup: 'الترجمة المهنية',
        officialGroup: 'الترجمة الرسمية',
        documentsGroup: 'الوثائق',
        interpretingGroup: 'الترجمة الفورية',
        otherGroup: 'خدمات أخرى',
        general: 'ترجمة عامة',
        specialized: 'ترجمة متخصصة',
        legal: 'ترجمة قانونية',
        technical: 'ترجمة تقنية',
        medical: 'ترجمة طبية',
        financial: 'ترجمة مالية',
        commercial: 'ترجمة تجارية',
        marketing: 'ترجمة تسويقية',
        tourism: 'ترجمة سياحية',
        sworn: 'ترجمة محلّفة',
        certified: 'ترجمة مصادق عليها',
        legalization: 'تصديق',
        apostille: 'أبوستيل',
        personal: 'وثائق شخصية',
        administrative: 'وثائق إدارية',
        academic: 'شهادات ودبلومات',
        legalDocs: 'وثائق قانونية',
        commercialDocs: 'وثائق تجارية',
        medicalDocs: 'وثائق طبية',
        simultaneous: 'ترجمة فورية متزامنة',
        consecutive: 'ترجمة فورية تتابعية',
        liaison: 'ترجمة فورية مرافقة',
        judicial: 'ترجمة فورية قضائية',
        medicalInterpreting: 'ترجمة فورية طبية',
        businessInterpreting: 'ترجمة فورية في المؤسسات',
        remoteInterpreting: 'ترجمة فورية عن بُعد',
        phone: 'هاتفية',
        video: 'عبر الفيديو',
        transcription: 'النسخ وإعادة النسخ',
        voiceover: 'التعليق الصوتي',
      },
      otherServices: 'خدمات أخرى',
    },
    hero: {
      title: 'ترجمات رسمية سريعة لكل وثائقك//بـ [سعر لا يُنافس]',
      subtitle:
        'وفّر الوقت واطمئن: مترجمون معتمدون يتولّون إجراءاتك الإدارية.',
      cta: 'اطلب عبر الإنترنت',
      ctaSecondary: 'عرض الخدمات',
      trust: 'ترجمات معتمدة من قبل خبراء مختصين، تُسلّم بصيغة PDF في أقل من 48 ساعة عبر ترجملك.',
    },
    stats: {
      words: 'كلمة مترجمة',
      pages: 'صفحة معتمدة',
      clients: 'عميل راضٍ',
      languages: 'لغة متاحة',
    },
    languagesCountries: {
      title: 'اللغات والبلدان التي نتعامل معها',
      subtitle: 'ترجمة احترافية في أكثر من 170 لغة وتصديق لأكثر من 70 دولة حول العالم',
      languagesTitle: 'اللغات',
      countriesTitle: 'البلدان',
      hubLabel: 'المقر — تونس',
      moreLanguages: '170+ لغة',
      moreCountries: '70+ دولة',
      mapHint: 'مرّر فوق بلد مميز على الخريطة',
      langContactHint: 'لم تجد زوج اللغات المناسب؟',
      langContactAction: 'اتصل بنا',
      mapLoading: 'جاري تحميل الخريطة…',
      mapError: 'تعذر تحميل الخريطة.',
      tunisia: 'تونس',
      france: 'فرنسا',
      uk: 'المملكة المتحدة',
      germany: 'ألمانيا',
      spain: 'إسبانيا',
      italy: 'إيطاليا',
      morocco: 'المغرب',
      algeria: 'الجزائر',
      libya: 'ليبيا',
      egypt: 'مصر',
      uae: 'الإمارات',
      saudi: 'السعودية',
      usa: 'الولايات المتحدة',
      canada: 'كندا',
      brazil: 'البرازيل',
      australia: 'أستراليا',
      india: 'الهند',
      china: 'الصين',
      japan: 'اليابان',
      turkey: 'تركيا',
      belgium: 'بلجيكا',
      switzerland: 'سويسرا',
      portugal: 'البرتغال',
      greece: 'اليونان',
      russia: 'روسيا',
      colombia: 'كولومبيا',
      chile: 'تشيلي',
      argentina: 'الأرجنتين',
      sudan: 'السودان',
      ethiopia: 'إثيوبيا',
      kenya: 'كينيا',
      tanzania: 'تنزانيا',
      southAfrica: 'جنوب أفريقيا',
      senegal: 'السنغال',
      ghana: 'غانا',
      nigeria: 'نيجيريا',
      jordan: 'الأردن',
      iraq: 'العراق',
      iran: 'إيران',
      yemen: 'اليمن',
      oman: 'عُمان',
      southKorea: 'كوريا الجنوبية',
      thailand: 'تايلاند',
      vietnam: 'فيتنام',
      malaysia: 'ماليزيا',
      indonesia: 'إندونيسيا',
      philippines: 'الفلبين',
      newZealand: 'نيوزيلندا',
    },
    steps: {
      title: 'كيف نعمل',
      subtitle: 'أربع خطوات بسيطة للحصول على ترجمتك المعتمدة',
      step1Title: 'اختر وثيقتك',
      step1Items: [
        'حدد نوع الوثيقة المراد ترجمتها.',
        'اختر زوج اللغات المطلوب.',
        'أدخل عدد الصفحات المراد ترجمتها.',
      ],
      step2Title: 'ارفع وثيقتك',
      step2Desc: 'أرسل مسحاً ضوئياً أو صورة لوثيقتك الأصلية.',
      step3Title: 'ادفع عبر الإنترنت',
      step3Desc: 'دفع آمن 100%.',
      step4Title: 'استلم ترجمتك المعتمدة',
      step4Desc:
        'استلم ترجمتك الرسمية عبر البريد الإلكتروني خلال 48 ساعة كحد أقصى بصيغة PDF.',
      orderOnline: 'أطلب عبر الإنترنت',
    },
    workProcess: {
      kicker: 'ترجمة عبر الإنترنت، بسيطة وسريعة',
      title: 'كيف ننجز عملك؟',
      intro:
        'في ترجملك، نضع التواصل واحترام الآجال والجودة في المقام الأول. نتبع مساراً واضحاً وشفافاً لتسليمك ترجمة متقنة من المرة الأولى، مهما كان حجم العمل أو ضيق الوقت.',
      steps: [
        {
          title: 'عرض السعر',
          text: 'بمجرد استلام وثيقتك، نبلغك بالسعر والأجل في غضون دقائق للمصادقة.',
        },
        {
          title: 'الترجمة',
          text: 'بعد تأكيد عرض السعر، نُسند ملفك إلى مترجم محلّف متمكّن من نوع وثيقتك.',
        },
        {
          title: 'المراجعة',
          text: 'يتولى مراجع مختص في مجالك التثبت من المصطلحات والشكل ومطابقة الأصل.',
        },
        {
          title: 'التسليم',
          text: 'تستلم ترجمتك المعتمدة عبر البريد الإلكتروني بصيغة PDF، ونأخذ ملاحظاتك بعين الاعتبار حتى النسخة النهائية.',
        },
      ],
      cta: 'أرسل وثيقتي',
    },
    homeZigzag: {
      title: 'ترجملك، منصة ترجمة معتمدة موثوقة',
      subtitle:
        'جميع الترجمات المعتمدة عبر ترجملك مخصّصة للإدارات التونسية والأجنبية.',
      row1Title: 'مترجمون معتمدون',
      row1Text:
        'تعتمد ترجملك على مترجمين محلّفين حاصلين على شهادات، متعددي اللغات وذوي خبرة في تخصصهم. يُسند كل ملف إلى خبير في المجال لضمان ترجمة دقيقة وملائمة لأهدافكم.',
      row2Title: 'مترجمون فوريون مؤهلون',
      row2Text:
        'شبكتنا من المترجمين الفوريين ذوي الخبرة تغطي أهم اللغات لضمان تواصل واضح في الاجتماعات حضورياً أو عن بُعد. مكوّنون في تخصصاتهم — قانوني وطبي وتقني وتسويقي — ويتقنون شكليات الترجمة الفورية والفعاليات المهنية.',
    },
    keyFigures: {
      title: 'ترجملك في أرقام',
      intro:
        'منذ سنوات، ترافق ترجملك الأفراد والمؤسسات والإدارات في تونس وخارجها بترجمات معتمدة موثوقة. سواء كنت تبحث عن شريك دائم لمشاريع الترجمة أو عن ترجمة رسمية لوثائقك، فريقنا إلى جانبك.',
      items: [
        { value: '+2 500', label: 'صفحة معتمدة' },
        { value: '+15', label: 'لغة' },
        { value: '+50', label: 'مترجم محلّف' },
        { value: '+1 200', label: 'عميل راضٍ' },
      ],
      cta: 'اطلب ترجمة',
    },
    homeLanguages: {
      title: 'ما هي اللغات التي نترجمها؟',
      intro:
        'نترجم وثائقكم إلى جميع لغات العالم لتلبية كل احتياجاتكم، عبر شبكة من المترجمين المحترفين في تونس وخارجها. إليكم بعض أكثر اللغات طلباً لدينا:',
      moreLanguages: 'المزيد من اللغات',
      featured: [
        { code: 'fr', name: 'الفرنسية' },
        { code: 'gb', name: 'الإنجليزية' },
        { code: 'it', name: 'الإيطالية' },
        { code: 'de', name: 'الألمانية' },
        { code: 'tn', name: 'العربية' },
      ],
    },
    languagesPage: {
      title: 'لغات الترجمة لدينا',
      subtitle:
        'ترجمة معتمدة واحترافية في أهم أزواج اللغات. لم تجد تركيبتك؟ تواصل معنا.',
      note:
        'نغطي أيضاً لغات وتركيبات أخرى حسب توفر مترجمينا. اطلب عرض أسعار مجاني لزوج اللغات الخاص بك.',
      cta: 'اطلب عرض أسعار',
      contact: 'تواصل معنا',
      languages: [
        {
          code: 'fr',
          name: 'الفرنسية',
          text: 'ترجمة فرنسية مصدّقة للإدارات والسفارات والمؤسسات.',
        },
        {
          code: 'gb',
          name: 'الإنجليزية',
          text: 'ترجمة إنجليزية للملفات الجامعية والهجرة والعقود والشركات.',
        },
        {
          code: 'it',
          name: 'الإيطالية',
          text: 'ترجمة إيطالية لوثائق الحالة المدنية والدراسة والإجراءات الإدارية.',
        },
        {
          code: 'es',
          name: 'الإسبانية',
          text: 'ترجمة إسبانية للإجراءات والدراسة والوثائق المهنية.',
        },
        {
          code: 'de',
          name: 'الألمانية',
          text: 'ترجمة ألمانية لملفات الدراسة والتأشيرات والعقود والوثائق التقنية.',
        },
        {
          code: 'tn',
          name: 'العربية',
          text: 'ترجمة معتمدة عربية للوثائق الرسمية والقانونية والأكاديمية والتجارية.',
        },
      ],
    },
    homeFeatured: {
      title: 'ترجمات معتمدة وترجمة فورية معتمدة',
      subtitle: 'اطلب بسهولة وسرعة عبر الإنترنت — ترجمة وترجمة فورية',
      seeMore: 'عرض المزيد',
      hints: {
        criminal: 'البطاقة عدد 3 (B3)',
        invoice: 'الشركة التونسية للكهرباء والغاز، الصوناد، اتصالات تونس، فواتير تجارية',
        apostilleDoc: 'اتفاقية لاهاي (1961)',
      },
      invoiceTypes: ['STEG', 'الصوناد', 'اتصالات تونس', 'تجارية'],
    },
    whatWeDo: {
      title: 'ماذا نفعل؟',
      items: [
        {
          title: 'الترجمة المحلّفة',
          text: 'وثائق رسمية يصدّقها مترجم معتمد، مقبولة لدى الإدارات والسفارات.',
          points: [
            'وثائق الحالة المدنية والشهادات والسجل العدلي',
            'ملفات التأشيرة والهجرة والتجنيس',
            'تسليم PDF معتمد خلال 48 ساعة (مستعجل 24 ساعة)',
          ],
        },
        {
          title: 'الترجمة الفورية',
          text: 'مترجمون فوريون مختصون لتواصل واضح، حضورياً أو عن بُعد.',
          points: [
            'فورية وتتابعية وربط',
            'قضائية وطبية وتجارية',
            'هاتفية ومؤتمرات فيديو',
          ],
        },
        {
          title: 'الترجمة القانونية',
          text: 'عقود وأحكام ووثائق تُترجم بدقة وسرية.',
          points: [
            'عقود وأنظمة أساسية ووثائق موثّقة',
            'أحكام وتوكيلات ووثائق المحاكم',
            'سرية مهنية مضمونة',
          ],
        },
        {
          title: 'المراسلات التجارية',
          text: 'مراسلات مؤسستكم تُترجم بوضوح واحترافية.',
          points: [
            'مراسلات وبريد إلكتروني ومذكرات',
            'طلبات عروض وكتالوجات',
            'نبرة مكيّفة مع قطاعكم',
          ],
        },
        {
          title: 'السفر والسياحة',
          text: 'وثائق السفر والمحتوى السياحي لإجراءات سلسة.',
          points: [
            'تأشيرات وحجوزات وشهادات',
            'أدلة وقوائم طعام ومواقع فنادق',
            'محتوى مكيّف لكل سوق',
          ],
        },
        {
          title: 'الترجمة المالية',
          text: 'ميزانيات وتقارير تُترجم بوضوح وشفافية وامتثال.',
          points: [
            'ميزانيات وبيانات نتائج وتقارير',
            'تدقيق وخطط أعمال وملفات مصرفية',
            'مصطلحات متوافقة مع المعايير',
          ],
        },
        {
          title: 'الترجمة التقنية',
          text: 'وثائق تقنية تُترجم بدقة ومصطلحات موحّدة.',
          points: [
            'أدلة وتعليمات وبطاقات تقنية',
            'كراسات شروط ومواصفات',
            'مصطلحات موحّدة',
          ],
        },
        {
          title: 'الترجمة الطبية',
          text: 'وثائق صحية تُترجم بدقة وسرية.',
          points: [
            'شهادات طبية وتقارير',
            'تحاليل ووصفات وملفات علاج',
            'سرّ طبي محترم',
          ],
        },
        {
          title: 'الترجمة التسويقية',
          text: 'محتوى يتردد لدى جمهوركم مع الحفاظ على هوية علامتكم.',
          points: [
            'حملات وشعارات ومحتوى رقمي',
            'كتيبات ومواقع ومتاجر إلكترونية',
            'تكييف ثقافي',
          ],
        },
      ],
    },
    translationTypes: {
      title: 'أنواع الترجمة لدينا',
      subtitle: 'من الترجمة المعتمدة إلى توطين المواقع — حل لكل احتياج',
      cta: 'جميع الخدمات',
      orderCta: 'اطلب عرض أسعار',
      sworn: 'ترجمة معتمدة',
      swornDesc: 'وثائق رسمية يصدّقها مترجم معتمد — مقبولة لدى الإدارات والسفارات.',
      website: 'ترجمة المواقع الإلكترونية',
      websiteDesc: 'صفحات ويب وتجارة إلكترونية وواجهات مكيّفة لجمهورك الدولي.',
      legal: 'ترجمة قانونية',
      legalDesc: 'عقود وأحكام وأنظمة أساسية ووثائق إجراءات بدقة عالية.',
      technical: 'ترجمة تقنية',
      technicalDesc: 'كتيبات وتعليمات ومواصفات ووثائق صناعية.',
      marketing: 'ترجمة تسويقية',
      marketingDesc: 'كتيبات وحملات ومحتوى رقمي ورسائل العلامة التجارية.',
      academic: 'ترجمة أكاديمية',
      academicDesc: 'شهادات وأطروحات ومقالات علمية وملفات تسجيل.',
      localization: 'التوطين',
      localizationDesc: 'تكييف لغوي وثقافي للبرامج والتطبيقات والمحتوى الرقمي.',
      subtitling: 'الترجمة والوسائط',
      subtitlingDesc: 'أفلام وفيديوهات وبودكاست ومحتوى متعدد الوسائط مترجم أو منسوخ.',
    },
    homeQuote: {
      title: 'لم تجد وثيقتك؟',
      subtitle: 'زوج اللغات غير متوفر؟',
      text: 'اطلب عرض أسعار مجاني ومخصّص. نرد خلال 30 دقيقة.',
      cta: 'اطلب عرض أسعار',
    },
    homeBlog: {
      title: 'المدونة',
      subtitle: 'نصائح وأخبار حول الترجمة المعتمدة',
      readMore: 'اقرأ المزيد',
      posts: [
        {
          slug: 'prix-traduction-assermentee',
          title: 'سعر الترجمة المعتمدة | أفضل التعريفات',
          excerpt: 'افهم أسعار الترجمة المصدّقة وما يؤثر في العرض.',
        },
        {
          slug: 'traduction-document-officiel',
          title: 'ترجمة وثيقة رسمية | معتمدة خلال 48 ساعة',
          excerpt: 'كيف تحصل على ترجمة معتمدة سريعة لإجراءاتك.',
        },
        {
          slug: 'releves-notes-diplomes',
          title: 'ترجمة كشوف النقاط والشهادات | 4 نصائح',
          excerpt: 'نقاط أساسية لترجمة وثائقك الأكاديمية دون رفض.',
        },
      ],
    },
    services: {
      title: 'خدمات الترجمة',
      subtitle: 'حلول للتونسيين في الخارج والسفارات والجامعات والشركات المتوسطية',
      legal: 'ترجمة قانونية',
      legalDesc: 'عقود وأحكام وإجراءات قضائية يترجمها خبراء.',
      certified: 'ترجمة معتمدة',
      certifiedDesc: 'وثائق رسمية معترف بها لدى المحاكم والإدارات التونسية.',
      academic: 'ترجمة أكاديمية',
      academicDesc: 'شهادات وكشوف نقاط وأطروحات للمعادلة والتسجيل.',
      medical: 'ترجمة طبية',
      medicalDesc: 'ملفات طبية وشهادات صحية للتأشيرة والتأمين.',
      commercial: 'ترجمة تجارية',
      commercialDesc: 'نظام أساسي وفواتير ووثائق شركة لتأسيس الأعمال.',
      apostille: 'أبوستille والتصديق',
      apostilleDesc: 'مرافقة للاعتراف الدولي بوثائقك.',
    },
    documents: {
      title: 'الوثائق الأكثر طلباً',
      subtitle: 'ترجمات معتمدة ابتداءً من 25 د.ت / صفحة',
      from: 'ابتداءً من',
      perPage: 'د.ت / صفحة',
      order: 'اطلب',
      birth: 'شهادة ميلاد',
      marriage: 'شهادة زواج',
      diploma: 'شهادة جامعية',
      transcript: 'كشف نقاط',
      criminal: 'سجل عدلي',
      passport: 'جواز سفر / بطاقة',
      idcard: 'بطاقة هوية',
      driving: 'رخصة قيادة',
      contract: 'عقد',
      judgment: 'حكم / قرار',
      power: 'توكيل',
      apostilleDoc: 'أبوستille',
    },
    serviceCatalog: serviceCatalogAr,
    servicesHub: {
      heroTitle: 'خدمات الترجمة لدينا',
      heroSubtitle: 'حل مُكيّف حسب وثيقتك ومجالك ومتطلباتك.',
      heroOrder: 'اطلب ترجمة',
      heroContact: 'اتصل بنا',
      profTitle: 'ترجمة مهنية',
      profIntro: 'حلول مُكيّفة لكل نوع من الوثائق ولكل قطاع.',
      officialTitle: 'ترجمة رسمية',
      officialIntro: 'للوثائق التي تتطلب قيمة قانونية أو تصديقًا أو اعترافًا دوليًا.',
      docsTitle: 'الوثائق',
      docsIntro: 'نترجم الوثائق الشخصية والإدارية والأكاديمية والقانونية والتجارية والطبية.',
      processTitle: 'كيف يعمل؟',
      processIntro: 'مسار واضح وشفاف من الطلب إلى التسليم.',
      processCta: 'شاهد آلية العمل',
      processSteps: [
        { title: 'أرسل وثيقتك', desc: 'حمّل وثيقتك وحدّد اللغات المطلوبة.' },
        { title: 'حدّد حاجتك', desc: 'اختر المجال ونوع الترجمة والمتطلبات الرسمية.' },
        { title: 'تحليل الطلب', desc: 'يحلّل المسؤول الطلب ويبحث النظام عن المحترفين المتوافقين.' },
        { title: 'استلم عرض السعر', desc: 'يُعدّ عرض السعر وفقًا لوثيقتك والخدمات المطلوبة.' },
        { title: 'الموافقة والدفع', desc: 'توافق على عرض السعر ثم تُتمّ عملية الدفع.' },
        { title: 'الترجمة والتدقيق', desc: 'يقوم المترجم بالعمل. يمكن إضافة تدقيق من محامٍ أو موثّق عند الضرورة.' },
        { title: 'التسليم', desc: 'يُراجع المستند النهائي ثم يُسلّم في حسابك.' },
      ],
      finalTitle: 'هل لديك وثيقة لترجمتها؟',
      finalText: 'أرسل وثيقتك واترك لنا تحديد الخدمة والمحترف المناسبين لحاجتك.',
      finalOrder: 'اطلب عبر الإنترنت',
      finalContact: 'اطلب معلومات',
      discover: 'اكتشف',
    },
    serviceTypes: {
      hubTitle: "خدمات الترجمة لدينا",
      hubSubtitle: "اختاروا المجال الذي يناسب وثيقتكم",
      choiceTitle: "بماذا تحتاجون؟",
      choiceIntro: "ترجمات رسمية (بختم) وترجمات حسب المجال (بدون ختم إداري).",
      officialBadge: "1",
      officialTitle: "ترجمة رسمية (بختم)",
      officialIntro: "للإدارة أو المحكمة أو السفارة أو الجامعة.",
      domainsBadge: "2",
      domainsTitle: "ترجمة حسب المجال",
      domainsIntro: "لشركتكم أو موقعكم أو الاستخدام اليومي.",
      seeServices: "عرض الخدمات",
      wantThisService: "اطلب عبر الإنترنت",
      wantThisServiceLead: "جاهزون للطلب؟ اطّلعوا على الأسعار ووثائق هذه الفئة.",
      backToChoice: "كل المجالات",
      catalogLabel: "خدمات هذه الفئة",
      page: {
        breadcrumbHome: "الرئيسية",
        breadcrumbServices: "الخدمات",
        quoteBadge: "عرض سعر في 30 دقيقة",
        quoteCta: "اطلب عرض سعر",
        quoteCardTitle: "اطلب عرض سعر",
        quoteCardText: "أرسلوا لنا وثيقتكم: تحصلون على سعر ومدة نهائيين في أقل من 30 دقيقة عمل.",
        quoteCardNote: "بدون التزام",
        docsTitle: "ما نتولّاه",
        seeAllServices: "عرض جميع الخدمات",
        introText:
          "في ترجملك، تُسند هذه الخدمة إلى مهنيين معتمدين يعرفون متطلبات الإدارات والشركات والمؤسسات. كل ملف يُعالج على حدة، ثم يُراجع ويُسلَّم في الأجل المُعلن.",
        introSubTitle: "لماذا الاستعانة بمهني؟",
        introSubText:
          "النتيجة غير الدقيقة ليست مجرد ركاكة في الأسلوب: قد تؤدي إلى رفض الملف أو تأخير الإجراءات أو سوء فهم بتبعات ثقيلة. الاستعانة بمهني تضمن نتيجة أمينة ومطابقة ومقبولة لدى الجهة المعنية.",
        whyTitle: "لماذا تُسندون هذه الخدمة إلى ترجملك؟",
        why: [
          {
            title: "خبرة في المجال",
            text: "كل ملف يُسند إلى مترجم يتقن الموضوع ومصطلحاته فعلاً.",
          },
          {
            title: "الأمانة والدقة",
            text: "التزام صارم بالوثيقة الأصلية والمصطلحات التقنية والتنسيق الأصلي.",
          },
          {
            title: "سرية مضمونة",
            text: "ملفاتكم تُنقل عبر اتصال آمن وتبقى مشمولة بالسر المهني.",
          },
          {
            title: "احترام المواعيد",
            text: "تُحدَّد المدة قبل الانطلاق. التسليم في 48 ساعة أو 24 ساعة للمستعجل.",
          },
        ],
        whyClosing: "أسندوا هذه الخدمة إلى مختصّينا، وأنجزوا إجراءاتكم في تونس وخارجها بكل اطمئنان.",
        inlineCta: "اتصلوا بنا اليوم للحصول على عرض سعر مخصّص!",
        guaranteesTitle: "ضماناتنا",
        guarantees: ["سرعة التفاعل", "جودة مثالية", "سرية مطلقة", "مترجمون معتمدون"],
        finalTitle: "اتصلوا بفريقنا",
        finalText: "تحدثوا معنا عن مشروعكم : نرشدكم نحو الحل المناسب ونرد عليكم بسرعة.",
        contactCta: "اتصلوا بنا",
      },
      types: {
        official: {
          title: "الترجمة الرسمية",
          cardDesc: "محلّفة، مصادق عليها، تصديق، أبوستيل.",
          pageTitle: "الترجمة الرسمية",
          pageLead: "وثائق موجهة للإدارات والمحاكم والهيئات الرسمية — ذات قيمة قانونية (ختم وتوقيع المترجم المعتمد).",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["ترجمة محلّفة", "ترجمة مصادق عليها", "تصديق الترجمة", "أبوستيل الوثائق"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "محلّفة أم مصادق عليها؟", a: "المحلّفة ينجزها مترجم محلّف للسلطات الوطنية؛ المصادق عليها تحمل ختماً ورقماً وغالباً للخارج. عند الشك نرشدكم حسب البلد." },
          ],
        },
        sworn: {
          title: "ترجمة محلّفة",
          cardDesc: "مترجم محلّف معتمد لدى المحاكم، بختم وتوقيع.",
          whenHint: "إذا طلبت الإدارة أو المحكمة مترجماً محلّفاً.",
          pageTitle: "ترجمة محلّفة",
          pageLead: "للترجمة المحلّفة قيمة قانونية وتعيد النص الأصلي دون تعديل.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["عقود الحالة المدنية", "أحكام وقرارات", "عقود موثقة", "السجل العدلي", "وثائق للمحاكم والإدارات"],
            },
          ],
        },
        certified: {
          title: "ترجمة مصادق عليها",
          cardDesc: "ختم وتوقيع ورقم ترجمة، مقبولة دولياً.",
          whenHint: "للشهادات والملفات الدولية والتصديق / الأبوستيل.",
          pageTitle: "ترجمة مصادق عليها",
          pageLead: "تضمن الترجمة المصادق عليها أصالة وثائقكم الرسمية.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["شهادات وكشوف نقاط", "عقود الحالة المدنية", "وثائق للتصديق أو الأبوستيل", "ملفات قنصلية وهجرة"],
            },
          ],
        },
        legalization: {
          title: "تصديق الترجمة",
          cardDesc: "تصديق للاعتراف الرسمي بترجمتكم.",
          whenHint: "عندما تطلب الإدارة تصديقاً بالإضافة إلى الترجمة.",
          pageTitle: "تصديق الترجمة",
          pageLead: "يؤكد التصديق صحة توقيع وختم المترجم لدى السلطات المختصة.",
          sections: [
            {
              title: "خدمات مرتبطة",
              list: ["تصديق الترجمة", "نسخة مطابقة للأصل", "إعادة إصدار ترجمة", "أبوستيل الوثائق"],
            },
          ],
        },
        apostille: {
          title: "أبوستيل الوثائق",
          cardDesc: "أبوستيل اتفاقية لاهاي للاعتراف الدولي.",
          whenHint: "لبلدان اتفاقية لاهاي.",
          pageTitle: "أبوستيل الوثائق",
          pageLead: "يبسّط الأبوستيل الاعتراف بوثيقة رسمية في الخارج دون تصديق قنصلي كامل.",
          sections: [
            {
              title: "خدمات مرتبطة",
              list: ["أبوستيل الوثائق", "تصديق الترجمة", "ترجمة مصادق عليها", "ترجمة محلّفة"],
            },
          ],
        },
        professional: {
          title: "ترجمة احترافية",
          cardDesc: "ترجمة بجودة عالية بدون ختم رسمي.",
          pageTitle: "ترجمة احترافية",
          pageLead: "للاستخدام اليومي أو المهني دون إجراءات إدارية.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["محتويات الشركات", "المواقع والتطبيقات", "التسويق والتواصل", "وثائق تقنية وتجارية"],
            },
          ],
        },
        legal: {
          title: "الترجمة القانونية",
          cardDesc: "عقود، أحكام، عقود موثقة، براءات…",
          pageTitle: "الترجمة القانونية",
          pageLead: "وثائق مرتبطة بالقانون بمصطلحات دقيقة.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["عقود", "أحكام", "عقود موثقة", "أنظمة أساسية للشركات", "الشروط العامة للبيع", "توكيلات", "اتفاقيات سرية (NDA)", "براءات اختراع", "علامات تجارية مسجلة", "وثائق الهجرة"],
            },
          ],
        },
        technical: {
          title: "الترجمة التقنية",
          cardDesc: "أدلة، نشرات تقنية، كراسات شروط…",
          pageTitle: "الترجمة التقنية",
          pageLead: "وثائق متخصصة في الصناعة والتكنولوجيا بمصطلحات دقيقة.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["أدلة الاستخدام", "نشرات تقنية", "وثائق صناعية", "كراسات شروط", "وثائق السيارات", "وثائق الطيران", "وثائق إلكترونية", "وثائق الطاقة", "وثائق ميكانيكية"],
            },
          ],
        },
        medical: {
          title: "الترجمة الطبية",
          cardDesc: "تقارير، وصفات، تجارب سريرية…",
          pageTitle: "الترجمة الطبية",
          pageLead: "وثائق القطاع الطبي والصيدلي بمصطلحات دقيقة.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["تقارير طبية", "وصفات طبية", "تحاليل طبية", "ملفات المرضى", "تجارب سريرية", "نشرات دوائية", "أجهزة طبية", "بروتوكولات بحث"],
            },
          ],
        },
        financial: {
          title: "الترجمة المالية",
          cardDesc: "موازين، تقارير سنوية، تدقيق…",
          pageTitle: "الترجمة المالية",
          pageLead: "وثائق اقتصادية ومالية.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["موازين محاسبية", "تقارير سنوية", "قوائم مالية", "تقارير تدقيق", "وثائق بنكية", "تأمينات", "جباية", "نشرات مالية"],
            },
          ],
        },
        commercial: {
          title: "الترجمة التجارية",
          cardDesc: "كتالوجات، كتيبات، طلبات عروض…",
          pageTitle: "الترجمة التجارية",
          pageLead: "وثائق مرتبطة بالشركات والمبادلات التجارية.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["كتالوجات", "كتيبات", "عروض تجارية", "مراسلات", "طلبات عروض", "عروض أسعار", "تقارير تجارية", "وثائق الموارد البشرية"],
            },
          ],
        },
        marketing: {
          title: "ترجمة التسويق",
          cardDesc: "حملات، شعارات، شبكات اجتماعية…",
          pageTitle: "ترجمة التسويق",
          pageLead: "تواصل وإشهار مكيّف لسوقكم المستهدف.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["حملات إعلانية", "شعارات", "نشرات إخبارية", "شبكات اجتماعية", "بلاغات صحفية", "مطويات تجارية", "تسويق بالبريد الإلكتروني", "هوية العلامة"],
            },
          ],
        },
        it: {
          title: "ترجمة المعلوماتية",
          cardDesc: "برمجيات، API، تطبيقات جوال…",
          pageTitle: "ترجمة المعلوماتية",
          pageLead: "وثائق مجال المعلوماتية والرقمنة.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["وثائق البرمجيات", "وثائق API", "أدلة المستخدم", "واجهات المستخدم", "برمجيات", "ألعاب فيديو", "تطبيقات الجوال", "وثائق الحوسبة السحابية"],
            },
          ],
        },
        scientific: {
          title: "الترجمة العلمية",
          cardDesc: "مقالات، أطروحات، منشورات…",
          pageTitle: "الترجمة العلمية",
          pageLead: "وثائق بحثية ومنشورات علمية.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["مقالات علمية", "منشورات", "أطروحات", "مذكرات", "تقارير مخبرية", "مجلات علمية"],
            },
          ],
        },
        digital: {
          title: "الترجمة الرقمية",
          cardDesc: "مواقع، توطين، SEO، تجارة إلكترونية…",
          pageTitle: "الترجمة الرقمية",
          pageLead: "خدمات مرتبطة بالويب: ترجمة وتوطين منصاتكم.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["ترجمة المواقع", "توطين المواقع", "توطين التطبيقات", "توطين البرمجيات", "ترجمة SEO", "ترجمة التجارة الإلكترونية", "ترجمة UX/UI"],
            },
          ],
        },
        website: {
          title: "ترجمة المواقع الإلكترونية",
          cardDesc: "مواقع تعريف ومتاجر وتطبيقات.",
          pageTitle: "ترجمة المواقع الإلكترونية",
          pageLead: "تكييف محتويات الويب مع لغة وثقافة جمهوركم.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["مواقع تعريف", "متاجر إلكترونية", "تطبيقات ويب", "محتويات وبطاقات منتجات"],
            },
          ],
        },
        audiovisual: {
          title: "الترجمة السمعية البصرية",
          cardDesc: "سترجة، دبلجة، تعليق صوتي…",
          pageTitle: "الترجمة السمعية البصرية",
          pageLead: "وسائط وفيديو: سترجة ودبلجة وتفريغ صوتي.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["سترجة", "دبلجة", "تعليق صوتي", "تفريغ صوتي", "تكييف سيناريوهات", "سترجة متعددة اللغات"],
            },
          ],
        },
        tourism: {
          title: "الترجمة السياحية",
          cardDesc: "أدلة، قوائم طعام، مواقع فنادق…",
          pageTitle: "الترجمة السياحية",
          pageLead: "قطاع السياحة والفندقة بأسلوب واضح وجذاب.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["أدلة سياحية", "كتيبات", "قوائم طعام", "مواقع الفنادق", "وكالات أسفار", "تطبيقات سياحية"],
            },
          ],
        },
        luxury: {
          title: "ترجمة الفخامة",
          cardDesc: "مجوهرات، ساعات، أزياء، عطور…",
          pageTitle: "ترجمة الفخامة",
          pageLead: "قطاعات راقية: كل كلمة تحترم صورة العلامة.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["مجوهرات", "ساعات فاخرة", "أزياء", "عطور", "مستحضرات تجميل", "فندقة فاخرة"],
            },
          ],
        },
        interpreting: {
          title: "الترجمة الفورية",
          cardDesc: "مؤتمرات، مهنية وعن بُعد.",
          pageTitle: "الترجمة الفورية",
          pageLead: "مترجمون فوريون لاجتماعاتكم ومواعيدكم وفعالياتكم — حضورياً أو عن بُعد.",
          sections: [
            {
              title: "الوثائق المشمولة",
              list: ["ترجمة فورية متزامنة", "ترجمة تتابعية", "ترجمة مرافقة", "ترجمة قضائية", "ترجمة طبية", "ترجمة هاتفية", "ترجمة عبر الفيديو"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "كيف أحجز؟", a: "حدّدوا التاريخ والمدة واللغات والنمط. نؤكد السعر والملف المناسب." },
          ],
        },
        simultaneous: {
          title: "الترجمة الفورية المتزامنة",
          cardDesc: "في الوقت الحقيقي، في كابينة أو بجهاز متنقل.",
          pageTitle: "الترجمة الفورية المتزامنة",
          pageLead: "يترجم المترجم في الوقت الحقيقي أثناء حديث المتكلم. الحل الأمثل للمؤتمرات والفعاليات الكبرى متعددة اللغات.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["المؤتمرات والندوات الكبرى", "الملتقيات والمنتديات الدولية", "الجمعيات العامة", "التكوينات متعددة اللغات", "الفعاليات المنقولة مباشرة"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["نوفّر مترجمين اثنين لكل لغة ولكل نصف يوم، لأن هذا العمل يتطلب تركيزاً عالياً. يمكن توفير التجهيزات (كابينة، سماعات، أجهزة استقبال) عند الطلب."],
              list: ["مترجمان لكل زوج لغات", "كابينة معزولة صوتياً أو نظام متنقل", "دراسة الوثائق التحضيرية مسبقاً"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "هل نحتاج تجهيزات؟", a: "نعم، كابينة أو نظام متنقل مع سماعات. يمكننا تضمينها في العرض أو العمل مع مزوّد القاعة." },
            { q: "لماذا مترجمان؟", a: "الترجمة المتزامنة تتطلب تركيزاً شديداً. يتبادل المترجمان الأدوار كل 20 إلى 30 دقيقة لضمان الجودة طوال المدة." },
            { q: "متى يجب الحجز؟", a: "من الأفضل قبل أسبوعين إلى ثلاثة للفعاليات، لتأمين الكفاءات والتجهيزات. الطلبات المستعجلة ممكنة حسب التوفّر." },
          ],
        },
        consecutive: {
          title: "الترجمة التتابعية",
          cardDesc: "يترجم المترجم بعد كل مداخلة.",
          pageTitle: "الترجمة التتابعية",
          pageLead: "يتحدث المتكلم ثم ينقل المترجم كلامه. لا تحتاج أي تجهيزات — مثالية للاجتماعات والمداخلات القصيرة.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["اجتماعات العمل والمفاوضات", "الخطابات والحفلات الرسمية", "زيارات الشركات والمصانع", "المؤتمرات الصحفية", "اللقاءات التقنية المحدودة"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["يأخذ المترجم ملاحظات أثناء المداخلة ثم ينقل الرسالة بدقة. احتسبوا حوالي ضعف مدة الحديث."],
              list: ["لا تحتاج أي تجهيزات", "مترجم واحد يكفي في معظم الحالات", "تحضير المصطلحات من وثائقكم"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "تتابعية أم متزامنة؟", a: "التتابعية تناسب الاجتماعات بأقل من 20 شخصاً والمداخلات القصيرة. فيما عدا ذلك، أو إذا كان الوقت ضيقاً، فالمتزامنة أفضل." },
            { q: "هل تضاعف مدة الاجتماع؟", a: "تقريباً: كل مداخلة تُقال مرتين. نأخذ ذلك في الحساب عند تقدير الوقت والسعر." },
          ],
        },
        liaison: {
          title: "الترجمة المرافقة",
          cardDesc: "مصاحبة فردية أو في مجموعة صغيرة.",
          pageTitle: "الترجمة المرافقة",
          pageLead: "يصاحبكم مترجم في إجراءاتكم ولقاءاتكم المحدودة، ناقلاً بين اللغتين مع سير المحادثة.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["المواعيد الإدارية والقنصلية", "التوقيع عند الموثق", "زيارات المواقع والمعارض المهنية", "مقابلات العمل", "مصاحبة الوفود"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["يبقى المترجم إلى جانبكم طوال مدة الموعد ويترجم في الاتجاهين، جملة بجملة. التحفّظ والحياد قاعدة أساسية."],
              list: ["الفوترة بالساعة أو بنصف اليوم", "إمكانية التنقل داخل تونس وخارجها", "سرية مضمونة"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "هل يمكن للمترجم التنقل؟", a: "نعم، في كل تونس وخارجها. تُذكر مصاريف التنقل في العرض قبل التأكيد." },
            { q: "ما هي المدة الدنيا؟", a: "ساعتان عموماً. بعد أربع ساعات يُطبّق سعر نصف اليوم." },
          ],
        },
        judicial: {
          title: "الترجمة القضائية",
          cardDesc: "المحاكم وجلسات الاستماع والعقود الموثقة.",
          pageTitle: "الترجمة القضائية",
          pageLead: "مترجمون محلّفون للجلسات وجلسات الاستماع والعقود الرسمية، حيث كل كلمة تحمل مسؤولية قانونية.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["الجلسات والمحاكمات", "جلسات الاستماع والإفادات", "العقود الموثقة والتوقيعات", "إجراءات الهجرة واللجوء", "التحقيقات والاستجوابات"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["لا يتدخل في هذه المهام إلا مترجمون محلّفون معتمدون من المحاكم. يتقنون مصطلحات الإجراءات وملزمون بالسر المهني."],
              list: ["مترجمون معتمدون من المحاكم التونسية", "نقل أمين دون تفسير أو إضافة", "سر مهني مطلق"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "هل المترجم محلّف؟", a: "نعم. لكل إجراء قضائي، نوكّل حصرياً مترجمين محلّفين معترفاً بهم من المحاكم." },
            { q: "هل يمكنكم التدخل بشكل مستعجل؟", a: "نتعامل مع الاستدعاءات المستعجلة حسب التوفّر. اتصلوا بنا بمجرد استلام تاريخ الجلسة." },
          ],
        },
        phone: {
          title: "الترجمة الهاتفية",
          cardDesc: "مترجم على الخط في دقائق.",
          pageTitle: "الترجمة الهاتفية",
          pageLead: "ينضم مترجم إليكم هاتفياً لمكالماتكم وإجراءاتكم عن بُعد، دون تنقل أو تجهيز.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["مكالمات مع إدارة أجنبية", "التعامل مع بنك أو شركة تأمين", "حجز مواعيد طبية بالخارج", "متابعة ملف قنصلي", "احتياجات مستعجلة وظرفية"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["تحدّدون اللغة والموعد المطلوب. ينضم المترجم إلى المكالمة في مؤتمر ثلاثي ويترجم مباشرة."],
              list: ["الفوترة بالدقيقة أو بحصص 15 دقيقة", "ربط سريع حسب اللغة", "لا حاجة لأي جهاز أو برنامج"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "في أي مدة يتوفر مترجم؟", a: "للغات الشائعة، غالباً في نفس اليوم. للغات النادرة، احتسبوا 24 إلى 48 ساعة." },
            { q: "كيف تجري المكالمة؟", a: "ننظّم مؤتمراً ثلاثياً: أنتم ومحدّثكم والمترجم. لا حاجة لأي تجهيز من جهتكم." },
          ],
        },
        video: {
          title: "الترجمة عبر الفيديو",
          cardDesc: "زوم، تيمز، ميت — عن بُعد ومتعددة اللغات.",
          pageTitle: "الترجمة عبر الفيديو",
          pageLead: "تصبح اجتماعاتكم عبر الإنترنت متعددة اللغات: ينضم المترجم إلى مؤتمركم المرئي ويترجم مباشرة.",
          sections: [
            {
              title: "متى تختارونها",
              list: ["اجتماعات الفرق الدولية", "الندوات والعروض عبر الإنترنت", "المقابلات والمناقشات عن بُعد", "لجان الإدارة متعددة اللغات", "المواعيد القنصلية بالفيديو"],
            },
            {
              title: "كيف نعمل",
              paragraphs: ["نتدخل على زوم وتيمز وغوغل ميت وأهم المنصات. في النمط المتزامن نستخدم قنوات اللغة عندما توفّرها المنصة."],
              list: ["متوافق مع Zoom وTeams وGoogle Meet وWebex", "نمط متزامن أو تتابعي حسب الصيغة", "اختبار تقني قبل الاجتماع"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "ما المنصات التي تدعمونها؟", a: "زوم ومايكروسوفت تيمز وغوغل ميت وويبكس ومعظم أدوات المؤتمرات المرئية. حدّدوا منصتكم عند الحجز." },
            { q: "هل نحتاج ترخيصاً خاصاً؟", a: "للترجمة المتزامنة بقنوات لغة منفصلة، يتطلب زوم ترخيصاً متوافقاً. وإلا نعمل بالنمط التتابعي دون قيود تقنية." },
          ],
        },
        transcription: {
          title: "النسخ وإعادة النسخ",
          cardDesc: "تحويل ملفاتكم الصوتية والمرئية إلى نصوص.",
          pageTitle: "النسخ وإعادة النسخ",
          pageLead: "نحوّل تسجيلاتكم الصوتية والمرئية إلى وثائق مكتوبة أمينة، بلغتها الأصلية أو مترجمة.",
          sections: [
            {
              title: "ما ننسخه",
              list: ["الاجتماعات واللجان والجمعيات", "المقابلات والحوارات", "المؤتمرات والتكوينات", "الجلسات والإفادات", "البودكاست والمحتوى المرئي", "الاستبيانات والدراسات النوعية"],
            },
            {
              title: "صيغ التسليم",
              paragraphs: ["تختارون مستوى الإنجاز حسب الاستخدام: نسخ حرفي كامل للاستخدام القانوني، أو صيغة منقّحة وسهلة القراءة للنشر."],
              list: ["نسخ حرفي كامل (كلمة بكلمة، مع التردّدات)", "صيغة منقّحة ومراجعة", "توقيت زمني وتحديد المتحدثين", "التسليم بصيغة Word أو PDF أو ملف سترجة"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "ما الفرق بين النسخ وإعادة النسخ؟", a: "النسخ يكتب التسجيل بلغته الأصلية. إعادة النسخ تضيف الترجمة إلى لغة أخرى." },
            { q: "كيف يُحسب السعر؟", a: "حسب مدة التسجيل وجودة الصوت وعدد المتحدثين ومستوى الإنجاز المطلوب." },
            { q: "وإذا كان الصوت سيئ الجودة؟", a: "نستمع إليه قبل تأكيد العرض. المقاطع غير المسموعة فعلاً تُشار في الوثيقة بدل تخمينها." },
          ],
        },
        voiceover: {
          title: "التعليق الصوتي",
          cardDesc: "تعليق صوتي احترافي ودبلجة وسترجة.",
          pageTitle: "التعليق الصوتي",
          pageLead: "نمنح صوتاً لمحتواكم بلغة جمهوركم: ترجمة النص والتسجيل والمزامنة.",
          sections: [
            {
              title: "ما ننتجه",
              list: ["الفيديوهات المؤسساتية", "وحدات التعليم الإلكتروني والدروس", "الإعلانات والومضات الإذاعية", "الأفلام الوثائقية والتقارير", "رسائل الاستقبال الهاتفي", "السترجة متعددة اللغات"],
            },
            {
              title: "مراحل العمل",
              paragraphs: ["يُترجم النص أولاً ويُكيّف مع مدة المقاطع، ثم يسجّله ممثل صوتي ناطق أصلي، وأخيراً يُزامن مع الفيديو."],
              list: ["ترجمة النص وتكييفه مع التوقيت", "أصوات أصلية، رجال ونساء، بنبرات متعددة", "تسجيل في استوديو", "مزج ومزامنة مع مونتاجكم"],
            },
          ],
          faqTitle: "أسئلة شائعة",
          faq: [
            { q: "هل يمكن اختيار الصوت؟", a: "نعم. نرسل لكم نماذج الأصوات المتوفرة باللغة المستهدفة وتصادقون عليها قبل التسجيل." },
            { q: "تعليق صوتي أم دبلجة؟", a: "التعليق الصوتي يضيف صوتاً سردياً فوق الشريط الأصلي. الدبلجة تستبدل الحوارات مع مزامنة حركة الشفاه. نوفّر الاثنين." },
            { q: "هل توفّرون السترجة أيضاً؟", a: "نعم، بصيغة SRT أو VTT، أو مدمجة مباشرة في الفيديو." },
          ],
        },
        general: { title: "ترجمة عامة", cardDesc: "ترجمة الوثائق الشخصية والإدارية اليومية." },
        specialized: { title: "ترجمة متخصصة", cardDesc: "قانونية، تقنية، طبية، مالية وتجارية." },
        personal: { title: "وثائق شخصية", cardDesc: "أوراق الحالة المدنية، جوازات السفر، بطاقات الهوية والشهادات." },
        administrative: { title: "وثائق إدارية", cardDesc: "رخص، بطاقات، شهادات متنوعة وإثباتات." },
        academic: { title: "شهادات ودبلومات", cardDesc: "ترجمة الدبلومات، كشوف النقاط والشهادات المدرسية." },
        legalDocs: { title: "وثائق قانونية", cardDesc: "عقود، أحكام، عقود موثقة وتوكيلات." },
        commercialDocs: { title: "وثائق تجارية", cardDesc: "كتالوجات، بروشورات، طلبات عروض وتقارير الشركات." },
        medicalDocs: { title: "وثائق طبية", cardDesc: "تقارير، وصفات طبية، تحاليل وملفات صحية." },
        medicalInterpreting: { title: "ترجمة فورية طبية", cardDesc: "مرافقة للاستشارات والملفات الصحية." },
        businessInterpreting: { title: "ترجمة فورية في المؤسسات", cardDesc: "اجتماعات، مفاوضات وفعاليات مهنية." },
        remoteInterpreting: { title: "ترجمة فورية عن بُعد", cardDesc: "هاتفياً أو عبر الفيديو، من أي مكان في العالم." },
      },
    },
    translators: translatorsAr,
    quoteWizard: quoteWizardAr,
    quoteForm: quoteFormAr,
    dashboard: dashboardAr,
    why: {
      title: 'لماذا ترجملك؟',
      quality: 'جودة معتمدة',
      qualityDesc: 'مترجمون معتمدون لدى المحاكم التونسية.',
      speed: 'تسليم سريع',
      speedDesc: 'PDF معتمد خلال 48 ساعة، خيار express 24 ساعة.',
      price: 'أسعار شفافة',
      priceDesc: 'عرض فوري بدون رسوم مخفية. دفع آمن.',
      support: 'دعم متعدد اللغات',
      supportDesc: 'مساعدة بالفرنسية والعربية والإنجليزية، 7 أيام/7.',
      guarantee: 'ضمان عدم الرفض',
      guaranteeDesc: 'إعادة ترجمة مجانية إذا رُفضت الوثيقة من سلطة رسمية.',
      digital: 'PDF معتمد + نسخ أصلية',
      digitalDesc: 'ترجمة رقمية عبر البريد أو حساب العميل. إرسال النسخ الورقية الأصلية عند طلب الإدارة.',
    },
    whyChoose: {
      kicker: 'ترجملِك',
      title: 'لماذا تختارنا',
      intro:
        'وثائق رسمية أو محتوى مؤسسات أو ملفات متخصصة: تُسند ترجملك كل مشروع إلى المترجم الذي يتقن الموضوع فعلاً.',
      cta: 'اكتشف كل خدماتنا',
      learnMore: 'عرض هذه الخدمة',
      commitmentsTitle: 'التزاماتنا',
      services: [
        {
          title: 'الترجمة المحلّفة',
          text: 'وثائق الحالة المدنية والشهادات والوثائق الإدارية تُترجم بختم وتوقيع مترجم معتمد.',
        },
        {
          title: 'ترجمة المواقع الإلكترونية',
          text: 'مواقع التعريف والمتاجر الإلكترونية والتطبيقات تُكيَّف مع سوقكم دون فقدان المعنى أو هوية علامتكم.',
        },
        {
          title: 'الترجمة التقنية',
          text: 'الأدلة والتعليمات وكراسات الشروط وبطاقات المنتجات بمصطلحات موحّدة بين كل الوثائق.',
        },
        {
          title: 'الترجمة القانونية',
          text: 'العقود والأحكام والأنظمة الأساسية والعقود الموثقة ينجزها مترجمون مطّلعون على القانون التونسي والدولي.',
        },
        {
          title: 'الترجمة الطبية',
          text: 'الشهادات والتقارير والتحاليل وملفات العلاج تُترجم بدقة وفي سرية تامة.',
        },
        {
          title: 'الترجمة المصادق عليها',
          text: 'ترجمات مطابقة للأصل ومقبولة لدى الإدارات والسفارات والجامعات والشركات.',
        },
      ],
      items: [
        {
          title: 'الجودة',
          text: 'كل ترجمة ينجزها مترجم محلّف معتمد لدى المحاكم التونسية، ثم تُراجع قبل الإرسال.',
        },
        {
          title: 'السرية',
          text: 'ملفاتكم تمر عبر اتصال آمن وتبقى مشمولة بالسر المهني ولا تُشارك أبداً.',
        },
        {
          title: 'الآجال',
          text: 'التسليم بصيغة PDF خلال 48 ساعة، أو 24 ساعة في الخدمة السريعة. يُؤكَّد الأجل قبل انطلاق العمل.',
        },
        {
          title: 'الأسعار',
          text: 'السعر المعلن يشمل الترجمة والمراجعة والتسليم والتصحيحات. لا زيادات بعد الطلب.',
        },
        {
          title: 'دعم على مدار الساعة',
          text: 'تواصلوا معنا في أي وقت عبر الدردشة أو البريد أو الرسائل أو الهاتف أو واتساب. رد سريع مهما كان توقيتكم.',
        },
      ],
    },
    trust: {
      title: 'ثقتكم، التزامنا',
      subtitle: 'شبكة مهنيين معتمدين في خدمة التونسيين في الخارج وحوض المتوسط',
      sworn: 'مترجمون معتمدون',
      swornDesc: 'معتمدون لدى المحاكم التونسية — مقبولون لدى الإدارات.',
      guarantee: 'ضمان عدم الرفض',
      guaranteeDesc: 'إعادة ترجمة مجانية إذا رُفضت وثيقتك من سلطة رسمية.',
      pricing: 'أسعار شفافة',
      pricingDesc: 'عرض فوري قبل التسجيل — بدون رسوم مخفية.',
      digital: 'تسليم مرن',
      digitalDesc: 'PDF معتمد خلال 48 ساعة — نسخ أصلية بالبريد عند الحاجة.',
      whatsapp: 'واتساب 24/7',
      whatsappDesc: 'دعم فوري للطلبات العاجلة ومتابعة الملف.',
      secure: 'دفع آمن',
      secureDesc: 'بطاقة بنكية أو تحويل — فاتورة تلقائية.',
    },
    useCases: {
      title: 'لجميع إجراءاتكم',
      subtitle: 'سفارات، تأشيرات، جامعات، شهادات وإجراءات إدارية في الخارج',
      visa: 'تأشيرة وإقامة',
      visaDesc: 'ملفات قنصلية، شهادات طبية، شهادات موارد.',
      immigration: 'هجرة وتجنيس',
      immigrationDesc: 'سجل عدلي، شهادات مدنية، ملفات لم شمل الأسرة.',
      studies: 'دراسة ومعادلة',
      studiesDesc: 'شهادات، كشوف نقاط، أطروحات للتسجيل الجامعي.',
      marriageAbroad: 'زواج في الخارج',
      marriageAbroadDesc: 'شهادات ميلاد، شهادات عزوبية، ترجمات موثقة.',
      business: 'تأسيس شركة',
      businessDesc: 'نظام أساسي، عقود تجارية، وثائق تسجيل.',
      legal: 'إجراءات قضائية',
      legalDesc: 'أحكام، توكيلات، عقود ووثائق للمحاكم.',
    },
    pricing: {
      title: 'أسعار شفافة',
      subtitle: 'أسعار معروضة علناً — عرض فوري بدون تسجيل',
      perPage: 'د.ت / صفحة',
      from: 'ابتداءً من',
      standard: 'عادي',
      express: 'سريع',
      urgent: 'عاجل',
      standardDelay: '4-5 أيام',
      expressDelay: '48 ساعة',
      urgentDelay: '24 ساعة',
      note: 'رسوم إضافية للسريع ×1.5 — العاجل ×2. أبوستيل 10–15 د.ت/وثيقة (تعريفة رسمية). يورو تقديري للخارج.',
      cta: 'احسب عرضي',
    },
    qa: {
      title: 'عملية مراقبة الجودة',
      subtitle: 'شفافية كاملة في كل مرحلة — من الاستلام إلى التسليم',
      step1: 'تقييم الملف',
      step1Desc: 'التحقق من وضوح واكتمال وملاءمة الوثيقة المصدر.',
      step2: 'ترجمة بواسطة خبير',
      step2Desc: 'مترجم معتمد متخصص في مجال الوثيقة.',
      step3: 'مراجعة لغوية',
      step3Desc: 'مراجعة لغوية ومصطلحاتية بواسطة مدقق مؤهل.',
      step4: 'تصديق رسمي',
      step4Desc: 'وضع الختم والتوقيع والذكر القانوني للمترجم المعتمد.',
      step5: 'تسليم آمن',
      step5Desc: 'إرسال PDF معتمد عبر البريد أو التحميل من حساب العميل.',
    },
    legal: {
      title: 'إشعار قانوني وشروط',
      refundTitle: 'سياسة الإلغاء والاسترداد',
      refundText: 'إلغاء مجاني قبل بدء الترجمة. استرداد كامل إذا أُلغي الطلب خلال ساعتين من الدفع. لا استرداد بعد تسليم الوثيقة المعتمدة، إلا في حالة تفعيل ضمان عدم الرفض.',
      termsTitle: 'الشروط العامة للبيع',
      termsText: 'ترجملك تقدم ترجمات معتمدة بواسطة مترجمين معتمدين. المواعيد المذكورة تقديرية في أيام العمل. العميل مسؤول عن جودة المسح المقدم.',
      privacyTitle: 'الخصوصية',
      privacyText: 'وثائقكم تُعالج بسرية تامة وتُحذف من خوادمنا بعد 90 يوماً من التسليم، ما لم يُطلب خلاف ذلك.',
    },
    faq: {
      title: 'أسئلة شائعة',
    },
    ecosystem: {
      title: 'منظومة مهنيين في خدمتكم',
      subtitle: 'ترجمة، أبوستille، استشارة قانونية ووثائق رسمية — عروض مجمّعة للتونسيين في الخارج',
      translator: 'مترجمون معتمدون',
      translatorDesc: 'ترجمات معتمدة مقبولة لدى السفارات والجامعات والإدارات.',
      notary: 'موثقون',
      notaryDesc: 'أبوستille وتصديق وتوثيق وثائقكم للاستخدام الدولي.',
      lawyer: 'محامون',
      lawyerDesc: 'استشارة قانونية ومرافقة لإجراءاتكم في الخارج.',
      bailiff: 'عدول تنفيذ',
      bailiffDesc: 'تبليغات ومحاضر وإجراءات لملفاتكم الرسمية.',
      note: 'ترجملك تجمع هؤلاء المهنيين لتقديم مسارات مبسّطة، من تونس إلى العالم.',
    },
    cta: {
      title: 'مستعد لترجمة وثائقك؟',
      subtitle: 'احصل على عرض مجاني في أقل من 60 دقيقة.',
      button: 'اطلب الآن',
    },
    reviews: {
      title: 'رضا العملاء',
      subtitle: 'تونسيون في الخارج ومؤسسات يثقون بنا لملفاتهم الرسمية',
      score: '4.9',
      basedOn: 'بناءً على أكثر من 340 تقييماً موثقاً',
      r1: {
        text: 'ترجمة شهادة ميلادي خلال 36 ساعة. قُبلت في سفارة تونس بباريس دون مشكلة.',
        name: 'سامي ب.',
        role: 'تونسي مقيم، فرنسا',
        doc: 'شهادة ميلاد',
      },
      r2: {
        text: 'ترجمت شهادتي للتسجيل في جامعة ألمانية. عملية بسيطة وسعر واضح.',
        name: 'إيناس م.',
        role: 'طالبة تونسية، ألمانيا',
        doc: 'شهادة جامعية',
      },
      r3: {
        text: 'دعم ممتاز لملف التأشيرة. ترجمة + أبوستille في خطوة واحدة.',
        name: 'كريم ح.',
        role: 'تونسي مقيم، كندا',
        doc: 'سجل عدلي',
      },
      r4: {
        text: 'شركتنا المتوسطية تستخدم ترجملك لجميع وثائقنا الرسمية. موثوق وسريع.',
        name: 'لورا ب.',
        role: 'مسؤولة موارد بشرية، إيطاليا',
        doc: 'عقد تجاري',
      },
      r5: {
        text: 'تجربة جيدة لتوكيل والديّ في تونس. قُبل كل شيء في الخارج.',
        name: 'أميرة ت.',
        role: 'تونسية مقيمة، بلجيكا',
        doc: 'توكيل',
      },
      r6: {
        text: 'ترجمة شهادة زواجي قُبلت في القنصلية دون أي مشكلة. أنصح بشدة.',
        name: 'يوسف ك.',
        role: 'تونسي مقيم، سويسرا',
        doc: 'شهادة زواج',
      },
    },
    footer: {
      description: 'ترجملك يرافق التونسيين المقيمين في الخارج والمؤسسات المتوسطية في إجراءاتهم الوثائقية الرسمية.',
      services: 'الخدمات',
      company: 'الشركة',
      legal: 'إشعار قانوني',
      privacy: 'الخصوصية',
      rights: 'جميع الحقوق محفوظة.',
      address: 'تونس، تونس',
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'فريقنا يرد خلال 60 دقيقة في أيام العمل.',
      civility: 'الصفة',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      message: 'رسالتك',
      send: 'إرسال',
      success: 'تم إرسال الرسالة! سنرد عليك قريباً.',
      badge: 'نحن في خدمتكم',
      breadcrumbHome: 'الرئيسية',
      infoTitle: 'معلومات الاتصال',
      formTitle: 'راسلونا',
      formHint: 'صفوا احتياجكم وسنعود إليكم سريعاً.',
      phoneLabel: 'الهاتف',
      emailLabel: 'البريد الإلكتروني',
      addressLabel: 'العنوان',
      hoursLabel: 'أوقات العمل',
      hoursValue: 'الاثنين – السبت · 8:00 – 20:00',
      whatsapp: 'الدردشة على واتساب',
      successAgain: 'إرسال رسالة أخرى',
      optional: 'اختياري',
      messagePlaceholder: 'الوثائق المطلوب ترجمتها، اللغات، المدة…',
    },
    order: {
      title: 'اطلب ترجمة',
      subtitle: 'اختر وثيقتك واللغات وأكمل الطلب في بضع خطوات.',
      step: 'خطوة',
      of: 'من',
      stepDoc: 'الوثيقة',
      stepFiles: 'الملفات',
      stepSummary: 'التأكيد',
      chooseDoc: 'اختر نوع الوثيقة',
      chooseLang: 'اختر زوج اللغات',
      allCategories: 'الكل',
      searchDocs: 'ابحث عن وثيقة…',
      noDocs: 'لم يتم العثور على وثائق.',
      perPage: '/ صفحة',
      yes: 'نعم',
      no: 'لا',
      stepDocHint: 'اختر الوثيقة ثم خيارات الترجمة.',
      stepFilesHint: 'أضف ملفاتك وأي تفاصيل مفيدة.',
      stepSummaryHint: 'راجع الملخص قبل التأكيد.',
      deliveryDigitalShort: 'PDF بالبريد',
      deliveryPhysicalShort: 'ورقي + PDF (+15 د.ت)',
      docType: 'نوع الوثيقة',
      langPair: 'زوج اللغات',
      pages: 'عدد الصفحات',
      urgency: 'الموعد المطلوب',
      standard: 'عادي (4-5 أيام)',
      express: 'سريع (48 ساعة)',
      urgent: 'عاجل (24 ساعة)',
      upload: 'ارفع وثائقك',
      uploadHint: 'PDF, JPG, PNG — 10 م.ب كحد أقصى',
      dragDrop: 'اسحب ملفاتك هنا أو انقر للتصفح',
      info: 'معلومات إضافية',
      infoPlaceholder: 'بلد الوجهة، إجراء خاص، تصديق...',
      next: 'التالي',
      prev: 'السابق',
      submit: 'تأكيد الطلب',
      summary: 'ملخص',
      estimated: 'التقدير',
      delivery: 'طريقة التسليم',
      deliveryDigital: 'رقمي (PDF معتمد عبر البريد)',
      deliveryPhysical: 'ورقي + رقمي — أصل عند الطلب (+15 د.ت)',
      apostille: 'أبوستيل / تصديق',
      apostilleAdd: 'إضافة أبوستيل (10–15 د.ت / وثيقة، تعريفة رسمية)',
      apostilleRange: '10–15 د.ت / وثيقة (تعريفة رسمية)',
      eurNote: 'مبالغ باليورو تقديرية للعملاء في الخارج.',
      successTitle: 'تم تأكيد الطلب!',
      successText: 'سنراجع وثائقك ونرسل تأكيداً عبر البريد خلال 60 دقيقة.',
      backHome: 'العودة للرئيسية',
      selectDoc: 'اختر وثيقة لرؤية التقدير',
      files: 'الملفات',
      fileUnit: 'ملف(ات)',
      loginBanner: 'سجّل الدخول لتأكيد طلبك واستلام ترجماتك في مساحتك الشخصية.',
      loginToSubmit: 'تسجيل الدخول للتأكيد',
    },
    auth: {
      loginTitle: 'تسجيل الدخول',
      loginSubtitle: 'ادخل إلى حسابك في ترجملك',
      registerTitle: 'إنشاء حساب',
      registerSubtitle: 'حساب مطلوب للطلب واستلام وثائقك',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      name: 'الاسم الكامل',
      loginButton: 'تسجيل الدخول',
      registerButton: 'إنشاء حسابي',
      noAccount: 'ليس لديك حساب؟',
      hasAccount: 'لديك حساب بالفعل؟',
      registerLink: 'إنشاء حساب',
      loginLink: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      dashboard: 'لوحة التحكم',
      myAccount: 'حسابي',
      loginRequiredText: 'يمكنك إعداد طلبك بحرية. لتأكيده، سجّل الدخول أو أنشئ حساباً.',
      invalidCredentials: 'البريد أو كلمة المرور غير صحيحة',
      emailNotFound: 'هذا البريد غير مسجل لدينا.',
      inactive: 'حسابك معطل. يرجى التواصل مع المسؤول.',
      currentPassword: 'كلمة المرور الحالية',
      confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
      changePassword: 'تغيير كلمة المرور',
      passwordChanged: 'تم تحديث كلمة المرور بنجاح.',
      wrongPassword: 'كلمة المرور الحالية غير صحيحة.',
      emailExists: 'هذا البريد مستخدم بالفعل',
      guestAccountExists: 'لقد طلبت سابقاً بهذا البريد. تم إرسال رسالة تفعيل الحساب إليك.',
      passwordTooShort: 'كلمة المرور يجب أن تحتوي على 6 أحرف على الأقل',
      passwordHint: 'يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم وحرف خاص.',
      passwordReqMin: '8 أحرف على الأقل',
      passwordReqUpper: 'حرف كبير',
      passwordReqLower: 'حرف صغير',
      passwordReqNumber: 'رقم',
      passwordReqSpecial: 'حرف خاص',
      passwordsMismatch: 'كلمتا المرور غير متطابقتين',
      invalidEmail: 'بريد إلكتروني غير صالح',
      invalidPayload: 'يرجى ملء جميع الحقول المطلوبة',
      termsNotAccepted: 'يجب قبول شروط الاستخدام',
      organizationNameRequired: 'اسم الشركة أو المنظمة مطلوب',
      registerSuccess: 'تم إنشاء حسابك بنجاح. جاري التحويل…',
      welcomeBack: 'تسجيل الدخول',
      loginFormHint: 'ادخل إلى حسابك.',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      perkSecure: 'دفع وبيانات آمنة',
      perkOrders: 'متابعة طلباتك عبر الإنترنت',
      perkDocs: 'ملفات PDF معتمدة جاهزة للتحميل',
      forgotLink: 'نسيت كلمة المرور؟',
      forgotTitle: 'إعادة تعيين كلمة المرور',
      forgotHint: 'أدخل بريدك للحصول على رابط إعادة التعيين.',
      forgotButton: 'إرسال الرابط',
      forgotSent: 'إذا وُجد الحساب، تم إرسال بريد إلكتروني يحتوي على رابط إعادة التعيين. يرجى التحقق من صندوق الوارد.',
      resetContinue: 'متابعة إعادة التعيين',
      resetTitle: 'كلمة مرور جديدة',
      resetHint: 'اختر كلمة مرور من 6 أحرف على الأقل.',
      resetToken: 'الرمز',
      newPassword: 'كلمة المرور الجديدة',
      resetButton: 'حفظ',
      resetDone: 'تم التحديث. جاري التحويل…',
      invalidToken: 'رابط غير صالح أو منتهٍ',
    },
    about: {
      title: 'عن ترجملك',
      subtitle: 'منصتكم للترجمة والترجمة الفورية الاحترافية',
      heroTagline: 'ترجمة، ترجمة فورية وخدمات وثائقية — بسيطة وموثوقة ومتاحة أينما كنتم.',
      whoWeAreTitle: 'من نحن؟',
      whoWeAreIntro: 'ترجملك منصة تونسية تُيسّر الوصول إلى الخدمات الوثائقية واللغوية للأفراد والشركات والمؤسسات.',
      mission: 'جعل كل إجراء ترجمة أو تصديق أو ترجمة فورية بسيطاً وموثوقاً ومتاحاً أينما كنتم.',
      vision: 'أن نصبح الجسر اللغوي والقانوني المرجعي بين تونس وأوروبا وبقية العالم.',
      values: 'الدقة، السرية، السرعة والاحترافية',
      positioning: 'ترجمة وترجمة فورية احترافية',
      servicesTitle: 'خدماتنا',
      servicesIntro: 'حلول ملائمة لكل حاجة، يُنجزها خبراء مؤهلون.',
      professionalTranslation: 'الترجمة الاحترافية',
      officialTranslation: 'الترجمة الرسمية',
      interpreting: 'الترجمة الفورية',
      additionalServices: 'خدمات إضافية',
      teamTitle: 'فريقنا',
      teamIntro: 'شبكة من محترفين ذوي خبرة معترف بهم في مجالاتهم.',
      translators: 'مترجمون',
      interpreters: 'مترجمون فوريون',
      lawyers: 'محامون',
      notaries: 'موثقون',
      processTitle: 'طريقة عملنا',
      processIntro: 'مسار واضح وشفاف، من الطلب إلى التسليم.',
      processSteps: [
        { title: 'طلب العميل', desc: 'تُودعون وثيقتكم أو تصفون حاجتكم.' },
        { title: 'التحليل', desc: 'نُقيّم نوع الوثيقة واللغة والاستعجال.' },
        { title: 'عرض السعر', desc: 'تتلقون سعراً وموعداً واضحين.' },
        { title: 'الدفع', desc: 'دفع آمن عبر الإنترنت.' },
        { title: 'التكليف', desc: 'محترف مؤهل يتولى ملفكم.' },
        { title: 'التنفيذ', desc: 'ترجمة وتدقيق وتنسيق حسب المعايير.' },
        { title: 'المراجعة', desc: 'مراقبة الجودة والتصديق عند الحاجة.' },
        { title: 'التسليم', desc: 'استلام الوثيقة إلكترونياً أو ورقياً حسب اختياركم.' },
      ],
      whyTitle: 'لماذا تختاروننا؟',
      whyIntro: 'نضع الخبرة والتنظيم في خدمة كل مشروع.',
      whyPoints: [
        { title: 'مترجمون متخصصون', desc: 'كل ملف يُسند إلى خبير في المجال.' },
        { title: 'لغات متعددة', desc: 'تغطية واسعة لحاجاتكم متعددة اللغات.' },
        { title: 'خبرة حسب المجال', desc: 'قانوني، طبي، تقني، تجاري، أكاديمي.' },
        { title: 'تدقيق مهني', desc: 'مراجعة ومراقبة جودة منهجية.' },
        { title: 'متابعة الطلب', desc: 'مسؤول متابع وإطلاع على كل مرحلة.' },
        { title: 'احترام الآجال', desc: 'تسليم في الموعد المتفق عليه، حتى في الحالات المستعجلة.' },
        { title: 'سرية', desc: 'وثائقكم تُعالج بأعلى درجات الأمان.' },
      ],
      commitmentTitle: 'التزامنا',
      commitmentIntro: 'نلتزم بقيم قوية تضمن لكم الراحة.',
      commitments: [
        'الجودة',
        'السرية',
        'الموثوقية',
        'احترام الآجال',
        'مرافقة العميل',
      ],
      ctaTitle: 'تحتاجون إلى ترجمة أو مترجم فوري؟',
      ctaText: 'اطلبوا عبر الإنترنت أو اتصلوا بنا للحصول على عرض مخصص.',
      orderButton: 'اطلبوا عبر الإنترنت',
      contactButton: 'اتصلوا بنا',
    },
    translator: {
      title: 'انضم إلى شبكة مترجمينا',
      subtitle: 'أكثر من 100 مترجم معتمد يتعاونون مع ترجملك.',
      apply: 'قدّم الآن',
      civility: 'الصفة',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      langPairs: 'أزواج اللغات',
      langPairsHint: 'أضف زوجًا واحدًا أو أكثر (لغة المصدر ← لغة الهدف).',
      fromLang: 'من',
      toLang: 'إلى',
      addPair: 'إضافة',
      selectLang: 'اختر',
      pairRequired: 'أضف زوج لغات واحدًا على الأقل.',
      specialization: 'التخصص',
      experience: 'الخبرة (بالسنوات)',
      cv: 'السيرة الذاتية / الملف (PDF)',
      choose: '—',
      specialties: {
        legal: 'قانونية',
        medical: 'طبية',
        academic: 'أكاديمية',
        commercial: 'تجارية',
        technical: 'تقنية',
      },
      perk1: 'مشاريع دولية متنوعة',
      perk2: 'أجر تنافسي',
      perk3: 'شبكة تضم أكثر من 100 مترجم',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      translation: 'Translation',
      certifiedTranslation: 'Certified translation',
      professionalTranslation: 'Professional translation',
      interpreting: 'Interpreting',
      documents: 'Documents',
      order: 'Order online',
      howItWorks: 'How it works',
      faq: 'FAQ',
      about: 'About',
      contact: 'Contact',
      translator: 'Join as translator',
      translators: 'Our network',
      orderNow: 'Order online',
      login: 'Log in',
      menu: 'Menu',
      language: 'Language',
      topMessage: 'Your documents translated & certified — certified PDF + originals on request ✦',
      viewAllServices: 'All translations',
      viewAllInterpreting: 'All interpreting services',
      viewMore: 'View all',
      servicesCategoriesLabel: 'Translation specialties',
      servicesMenu: {
        specialtiesTitle: 'Services',
        professionalGroup: 'Professional translation',
        officialGroup: 'Official translation',
        documentsGroup: 'Documents',
        interpretingGroup: 'Interpreting',
        otherGroup: 'Other services',
        general: 'General translation',
        specialized: 'Specialized translation',
        legal: 'Legal translation',
        technical: 'Technical translation',
        medical: 'Medical translation',
        financial: 'Financial translation',
        commercial: 'Commercial translation',
        marketing: 'Marketing translation',
        tourism: 'Tourism translation',
        sworn: 'Sworn translation',
        certified: 'Certified translation',
        legalization: 'Legalization',
        apostille: 'Apostille',
        personal: 'Personal documents',
        administrative: 'Administrative documents',
        academic: 'Diplomas & certificates',
        legalDocs: 'Legal documents',
        commercialDocs: 'Commercial documents',
        medicalDocs: 'Medical documents',
        simultaneous: 'Simultaneous interpreting',
        consecutive: 'Consecutive interpreting',
        liaison: 'Liaison interpreting',
        judicial: 'Judicial interpreting',
        medicalInterpreting: 'Medical interpreting',
        businessInterpreting: 'Business interpreting',
        remoteInterpreting: 'Remote interpreting',
        phone: 'Telephone',
        video: 'Video conference',
        transcription: 'Transcription & retranscription',
        voiceover: 'Voice-over',
      },
      otherServices: 'Other services',
    },
    hero: {
      title: 'YOUR OFFICIAL DOCUMENTS TRANSLATED FAST//AT AN [UNBEATABLE PRICE]',
      subtitle:
        'Save time on your administrative procedures with sworn translators you can trust.',
      cta: 'ORDER ONLINE',
      ctaSecondary: 'BROWSE SERVICES',
      trust: 'Certified translations by sworn experts, delivered as PDF in under 48h through Tarjemlek.',
    },
    stats: {
      words: 'Words translated',
      pages: 'Certified pages',
      clients: 'Satisfied clients',
      languages: 'Languages available',
    },
    languagesCountries: {
      title: 'Languages and countries we deal with',
      subtitle: 'Professional translation in 170+ languages and attestation for 70+ countries worldwide',
      languagesTitle: 'Languages',
      countriesTitle: 'Countries',
      hubLabel: 'Headquarters — Tunis',
      moreLanguages: '170+ languages',
      moreCountries: '70+ countries',
      mapHint: 'Hover a highlighted country on the map',
      langContactHint: 'Can\'t find your language pair?',
      langContactAction: 'Contact us',
      mapLoading: 'Loading map…',
      mapError: 'Unable to load map.',
      tunisia: 'Tunisia',
      france: 'France',
      uk: 'United Kingdom',
      germany: 'Germany',
      spain: 'Spain',
      italy: 'Italy',
      morocco: 'Morocco',
      algeria: 'Algeria',
      libya: 'Libya',
      egypt: 'Egypt',
      uae: 'UAE',
      saudi: 'Saudi Arabia',
      usa: 'United States',
      canada: 'Canada',
      brazil: 'Brazil',
      australia: 'Australia',
      india: 'India',
      china: 'China',
      japan: 'Japan',
      turkey: 'Turkey',
      belgium: 'Belgium',
      switzerland: 'Switzerland',
      portugal: 'Portugal',
      greece: 'Greece',
      russia: 'Russia',
      colombia: 'Colombia',
      chile: 'Chile',
      argentina: 'Argentina',
      sudan: 'Sudan',
      ethiopia: 'Ethiopia',
      kenya: 'Kenya',
      tanzania: 'Tanzania',
      southAfrica: 'South Africa',
      senegal: 'Senegal',
      ghana: 'Ghana',
      nigeria: 'Nigeria',
      jordan: 'Jordan',
      iraq: 'Iraq',
      iran: 'Iran',
      yemen: 'Yemen',
      oman: 'Oman',
      southKorea: 'South Korea',
      thailand: 'Thailand',
      vietnam: 'Vietnam',
      malaysia: 'Malaysia',
      indonesia: 'Indonesia',
      philippines: 'Philippines',
      newZealand: 'New Zealand',
    },
    steps: {
      title: 'How it works',
      subtitle: 'Four simple steps to get your certified translation',
      step1Title: 'Select your document',
      step1Items: [
        'Select the type of document to translate.',
        'Choose the required language pair.',
        'Indicate the number of pages to translate.',
      ],
      step2Title: 'Upload your document',
      step2Desc: 'Send a scan or photo of your original document.',
      step3Title: 'Pay online',
      step3Desc: '100% secure payment.',
      step4Title: 'Receive your certified translation',
      step4Desc:
        'Receive your official translation by email within 48 hours maximum, as a PDF.',
      orderOnline: 'Order online',
    },
    workProcess: {
      kicker: 'Online translation, simple and fast',
      title: 'How do we handle your work?',
      intro:
        'At Tarjemlek, communication, deadlines and quality come first. We follow a clear, transparent process so your translation is flawless the first time — whatever the volume or the urgency.',
      steps: [
        {
          title: 'Quote',
          text: 'As soon as we receive your document, we send you the price and turnaround time within minutes for your approval.',
        },
        {
          title: 'Translation',
          text: 'Once the quote is confirmed, your file is assigned to a sworn translator familiar with your type of document.',
        },
        {
          title: 'Review',
          text: 'A specialist reviewer in your field checks terminology, formatting and consistency with the original.',
        },
        {
          title: 'Delivery',
          text: 'You receive your certified translation by email as a PDF, and we take your feedback into account until the final version.',
        },
      ],
      cta: 'Send my document',
    },
    homeZigzag: {
      title: 'Tarjemlek, a trusted sworn translation platform',
      subtitle:
        'All sworn translations delivered through Tarjemlek are intended for Tunisian and foreign authorities.',
      row1Title: 'Approved translators',
      row1Text:
        'Tarjemlek works with sworn, qualified translators — multilingual and experienced in their field. Every project is matched with a subject-matter expert for accurate, goal-oriented results.',
      row2Title: 'Qualified interpreters',
      row2Text:
        'Our network of experienced interpreters covers the main languages for clear communication in meetings, on-site or online. Trained in their specialties — legal, medical, technical or marketing — they master interpreting protocols and professional events.',
    },
    keyFigures: {
      title: 'Tarjemlek in numbers',
      intro:
        'For years, Tarjemlek has supported individuals, companies and public bodies in Tunisia and abroad with reliable sworn translations. Whether you are looking for a long-term translation partner or a one-off official translation, our team is here for you.',
      items: [
        { value: '2,500+', label: 'Certified pages' },
        { value: '15+', label: 'Languages' },
        { value: '50+', label: 'Sworn translators' },
        { value: '1,200+', label: 'Satisfied clients' },
      ],
      cta: 'Request a translation',
    },
    homeLanguages: {
      title: 'Which languages do we translate?',
      intro:
        'We translate your documents into all the languages of the world to meet all your needs, through a network of professional translators in Tunisia and abroad. Here are some of our most requested languages:',
      moreLanguages: 'More languages',
      featured: [
        { code: 'fr', name: 'French' },
        { code: 'gb', name: 'English' },
        { code: 'it', name: 'Italian' },
        { code: 'de', name: 'German' },
        { code: 'tn', name: 'Arabic' },
      ],
    },
    languagesPage: {
      title: 'Our translation languages',
      subtitle:
        'Sworn and professional translation in the main language pairs. Don\'t see your combination? Contact us.',
      note:
        'We also cover other languages and combinations depending on translator availability. Request a free quote for your language pair.',
      cta: 'Request a quote',
      contact: 'Contact us',
      languages: [
        {
          code: 'fr',
          name: 'French',
          text: 'Certified French translation for administrations, embassies and institutions.',
        },
        {
          code: 'gb',
          name: 'English',
          text: 'English translation for university files, immigration, contracts and companies.',
        },
        {
          code: 'it',
          name: 'Italian',
          text: 'Italian translation for civil-status documents, studies and administrative procedures.',
        },
        {
          code: 'es',
          name: 'Spanish',
          text: 'Spanish translation for procedures, studies and professional documents.',
        },
        {
          code: 'de',
          name: 'German',
          text: 'German translation for study files, visas, contracts and technical documents.',
        },
        {
          code: 'tn',
          name: 'Arabic',
          text: 'Sworn Arabic translation for official, legal, academic and business documents.',
        },
      ],
    },
    homeFeatured: {
      title: 'Sworn translations and certified interpreting',
      subtitle: 'Order online simply and quickly — translation and interpreting',
      seeMore: 'See more',
      hints: {
        criminal: 'Bulletin no. 3 (B3)',
        invoice: 'STEG, SONEDE, Tunisie Telecom, commercial invoices',
        apostilleDoc: 'Hague Convention (1961)',
      },
      invoiceTypes: ['STEG', 'SONEDE', 'Tunisie Telecom', 'Commercial'],
    },
    whatWeDo: {
      title: 'What do we do?',
      items: [
        {
          title: 'Sworn translation',
          text: 'Official documents certified by an approved translator, accepted by authorities and embassies.',
          points: [
            'Civil status records, diplomas and criminal records',
            'Visa, immigration and naturalisation files',
            'Certified PDF delivery within 48h (express 24h)',
          ],
        },
        {
          title: 'Interpreting',
          text: 'Specialist interpreters for clear communication, on-site or remotely.',
          points: [
            'Simultaneous, consecutive and liaison',
            'Judicial, medical and commercial',
            'Telephone and video conference',
          ],
        },
        {
          title: 'Legal translation',
          text: 'Contracts, judgments and deeds translated with precision and confidentiality.',
          points: [
            'Contracts, articles of association and notarial deeds',
            'Judgments, powers of attorney and court documents',
            'Professional secrecy guaranteed',
          ],
        },
        {
          title: 'Business correspondence',
          text: 'Your corporate exchanges translated with clarity and professionalism.',
          points: [
            'Letters, emails and internal notes',
            'Tenders, catalogues and proposals',
            'Tone tailored to your sector',
          ],
        },
        {
          title: 'Travel & tourism',
          text: 'Travel documents and tourism content translated for smooth procedures.',
          points: [
            'Visas, bookings and certificates',
            'Guides, menus and hotel websites',
            'Content adapted to each market',
          ],
        },
        {
          title: 'Financial translation',
          text: 'Balance sheets and reports translated with clarity, transparency and compliance.',
          points: [
            'Balance sheets, income statements and reports',
            'Audits, business plans and banking files',
            'Terminology aligned with standards',
          ],
        },
        {
          title: 'Technical translation',
          text: 'Technical documents translated with precision and consistent terminology.',
          points: [
            'Manuals, notices and technical data sheets',
            'Specifications and statements of work',
            'Consistent terminology',
          ],
        },
        {
          title: 'Medical translation',
          text: 'Healthcare documents translated with rigour and confidentiality.',
          points: [
            'Medical certificates and reports',
            'Lab results, prescriptions and care files',
            'Medical secrecy respected',
          ],
        },
        {
          title: 'Marketing translation',
          text: 'Content that resonates with your audience, brand voice preserved.',
          points: [
            'Campaigns, slogans and digital content',
            'Brochures, showcase sites and e-commerce',
            'Cultural adaptation',
          ],
        },
      ],
    },
    translationTypes: {
      title: 'Our translation types',
      subtitle: 'From sworn translation to web localization — a solution for every need',
      cta: 'All services',
      orderCta: 'Request a quote',
      sworn: 'Sworn translation',
      swornDesc: 'Official documents certified by an approved translator — accepted by authorities and embassies.',
      website: 'Website translation',
      websiteDesc: 'Web pages, e-commerce and interfaces tailored to your international audience.',
      legal: 'Legal translation',
      legalDesc: 'Contracts, judgments, statutes and procedural documents translated with precision.',
      technical: 'Technical translation',
      technicalDesc: 'Manuals, notices, specifications and industrial documentation.',
      marketing: 'Marketing translation',
      marketingDesc: 'Brochures, campaigns, digital content and brand messaging.',
      academic: 'Academic translation',
      academicDesc: 'Diplomas, theses, scientific papers and enrollment files.',
      localization: 'Localization',
      localizationDesc: 'Linguistic and cultural adaptation of software, apps and digital content.',
      subtitling: 'Subtitling & media',
      subtitlingDesc: 'Films, videos, podcasts and multimedia content subtitled or transcribed.',
    },
    homeQuote: {
      title: 'Can\'t find your document?',
      subtitle: 'Is your language pair not listed?',
      text: 'Request a free personalized quote. We reply within 30 minutes.',
      cta: 'Request a quote',
    },
    homeBlog: {
      title: 'Blog',
      subtitle: 'Tips and news on sworn translation',
      readMore: 'Read more',
      posts: [
        {
          slug: 'prix-traduction-assermentee',
          title: 'Cost of a sworn translation | Best rates',
          excerpt: 'Understand certified translation pricing and what affects your quote.',
        },
        {
          slug: 'traduction-document-officiel',
          title: 'Official document translation | Certified in 48h',
          excerpt: 'How to get a fast sworn translation for your procedures.',
        },
        {
          slug: 'releves-notes-diplomes',
          title: 'Transcripts & diplomas | 4 pro tips',
          excerpt: 'Key points to translate academic documents without rejection.',
        },
      ],
    },
    services: {
      title: 'Our translation services',
      subtitle: 'Solutions for Tunisians abroad, embassies, universities and Mediterranean businesses',
      legal: 'Legal translation',
      legalDesc: 'Contracts, judgments, court procedures translated by experts.',
      certified: 'Certified translation',
      certifiedDesc: 'Certified and legalized translations accepted by authorities.',
      academic: 'Academic translation',
      academicDesc: 'Diplomas, transcripts, theses for equivalence and enrollment.',
      medical: 'Medical translation',
      medicalDesc: 'Medical records, health certificates for visa and insurance.',
      commercial: 'Commercial translation',
      commercialDesc: 'Statutes, invoices, company documents for business setup.',
      apostille: 'Apostille & legalization',
      apostilleDesc: 'Support for international recognition of your documents.',
    },
    documents: {
      title: 'Most requested documents',
      subtitle: 'Sworn translations from 25 TND / page',
      from: 'From',
      perPage: 'TND / page',
      order: 'Order',
      birth: 'Birth certificate',
      marriage: 'Marriage certificate',
      diploma: 'University diploma',
      transcript: 'Academic transcript',
      criminal: 'Criminal record',
      passport: 'Passport / ID',
      idcard: 'Identity card',
      driving: 'Driving license',
      contract: 'Contract',
      judgment: 'Judgment / Ruling',
      power: 'Power of attorney',
      apostilleDoc: 'Apostille',
    },
    serviceCatalog: serviceCatalogEn,
    servicesHub: {
      heroTitle: 'Our translation services',
      heroSubtitle: 'A solution tailored to your document, field and requirements.',
      heroOrder: 'Order a translation',
      heroContact: 'Contact us',
      profTitle: 'Professional translation',
      profIntro: 'Solutions tailored to every document type and industry.',
      officialTitle: 'Official translation',
      officialIntro: 'For documents requiring legal value, certification or international recognition.',
      docsTitle: 'Documents',
      docsIntro: 'We translate personal, administrative, academic, legal, commercial and medical documents.',
      processTitle: 'How does it work?',
      processIntro: 'A clear, transparent process from request to delivery.',
      processCta: 'See how it works',
      processSteps: [
        { title: 'Upload your document', desc: 'Upload your document and select the languages you need.' },
        { title: 'Specify your needs', desc: 'Choose the field, translation type and any official requirements.' },
        { title: 'Request analysis', desc: 'The administrator reviews your request and the system finds matching professionals.' },
        { title: 'Receive your quote', desc: 'Your quote is prepared based on your document and required services.' },
        { title: 'Approve and pay', desc: 'Accept the quote and proceed to secure payment.' },
        { title: 'Translation and review', desc: 'The translator completes the work. A lawyer or notary review can be added when needed.' },
        { title: 'Delivery', desc: 'The final document is checked and delivered to your client area.' },
      ],
      finalTitle: 'Have a document to translate?',
      finalText: 'Upload your document and let us identify the right service and professional for your needs.',
      finalOrder: 'Order online',
      finalContact: 'Request information',
      discover: 'Discover',
    },
    serviceTypes: {
      hubTitle: "Our translation services",
      hubSubtitle: "Choose the field that matches your document",
      choiceTitle: "What do you need?",
      choiceIntro: "Official translations (with seal) and domain translations (no administrative seal).",
      officialBadge: "1",
      officialTitle: "Official translation (with seal)",
      officialIntro: "For an authority, court, embassy or university.",
      domainsBadge: "2",
      domainsTitle: "Domain translation",
      domainsIntro: "For your business, website or everyday use.",
      seeServices: "View services",
      wantThisService: "Order online",
      wantThisServiceLead: "Ready to order? Browse rates and documents in this category.",
      backToChoice: "All fields",
      catalogLabel: "Services in this category",
      page: {
        breadcrumbHome: "Home",
        breadcrumbServices: "Services",
        quoteBadge: "Quote in 30 min",
        quoteCta: "Request a quote",
        quoteCardTitle: "Request a quote",
        quoteCardText: "Send us your document: you get a firm price and turnaround in under 30 working minutes.",
        quoteCardNote: "No commitment",
        docsTitle: "What we handle",
        seeAllServices: "See all services",
        introText:
          "At Tarjemlek, this service is handled by accredited professionals who know exactly what administrations, companies and institutions expect. Every file is handled individually, proofread, then delivered within the agreed deadline.",
        introSubTitle: "Why work with a professional?",
        introSubText:
          "An approximate result is not just a matter of style: it can lead to a rejected application, a procedural delay or a costly misunderstanding. Working with a professional means a faithful, compliant result that your recipient will accept.",
        whyTitle: "Why trust Tarjemlek with this service?",
        why: [
          {
            title: "Field expertise",
            text: "Every file goes to a translator who genuinely knows the subject and its terminology.",
          },
          {
            title: "Accuracy and precision",
            text: "Strict respect for the source document, technical terms and original formatting.",
          },
          {
            title: "Guaranteed confidentiality",
            text: "Your files travel over a secure connection and stay covered by professional secrecy.",
          },
          {
            title: "Deadlines met",
            text: "The deadline is confirmed before we start. Delivery within 48 h, or 24 h express.",
          },
        ],
        whyClosing:
          "Entrust this service to our specialists and handle your procedures, in Tunisia and abroad, with complete peace of mind.",
        inlineCta: "Contact us today for a tailored quote!",
        guaranteesTitle: "Our guarantees",
        guarantees: ["Responsiveness", "Optimal quality", "Absolute confidentiality", "Accredited translators"],
        finalTitle: "Contact our team",
        finalText: "Tell us about your project: we will guide you to the right solution and reply quickly.",
        contactCta: "Contact us",
      },
      types: {
        official: {
          title: "Official translation",
          cardDesc: "Sworn, certified, legalization, apostille.",
          pageTitle: "Official translation",
          pageLead: "Documents for authorities, courts and official bodies — with legal value (seal and signature of an accredited translator).",
          sections: [
            {
              title: "Documents covered",
              list: ["Sworn translation", "Certified translation", "Translation legalization", "Document apostille"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Sworn or certified?", a: "Sworn is done by a court-sworn translator for national authorities; certified carries a seal and number, often for international use. If unsure, we guide you by country." },
          ],
        },
        sworn: {
          title: "Sworn translation",
          cardDesc: "Court-sworn translator, with seal and signature.",
          whenHint: "If the authority or court requires a sworn translator.",
          pageTitle: "Sworn translation",
          pageLead: "Sworn translation has legal value and reproduces the source text without change.",
          sections: [
            {
              title: "Documents covered",
              list: ["Civil-status records", "Judgments and decisions", "Notarial deeds", "Criminal records", "Documents for courts and administrations"],
            },
          ],
        },
        certified: {
          title: "Certified translation",
          cardDesc: "Seal, signature and translation number, accepted internationally.",
          whenHint: "For diplomas, international files, legalization / apostille.",
          pageTitle: "Certified translation",
          pageLead: "Certified translation guarantees the authenticity of your official documents.",
          sections: [
            {
              title: "Documents covered",
              list: ["Diplomas and transcripts", "Civil-status records", "Documents to legalize or apostille", "Consular and immigration files"],
            },
          ],
        },
        legalization: {
          title: "Translation legalization",
          cardDesc: "Legalization for official recognition of your translation.",
          whenHint: "When the authority requires legalization in addition to translation.",
          pageTitle: "Translation legalization",
          pageLead: "Legalization attests the authenticity of the translator's signature and seal before the competent authorities.",
          sections: [
            {
              title: "Related services",
              list: ["Translation legalization", "Certified true copy", "Translation reissue", "Document apostille"],
            },
          ],
        },
        apostille: {
          title: "Document apostille",
          cardDesc: "Hague Convention apostille for international recognition.",
          whenHint: "For Hague Convention member countries.",
          pageTitle: "Document apostille",
          pageLead: "The apostille simplifies recognition of an official document abroad, without full consular legalization.",
          sections: [
            {
              title: "Related services",
              list: ["Document apostille", "Translation legalization", "Certified translation", "Sworn translation"],
            },
          ],
        },
        professional: {
          title: "Professional translation",
          cardDesc: "Quality translation without an official seal.",
          pageTitle: "Professional translation",
          pageLead: "For everyday or professional use, without administrative formalities.",
          sections: [
            {
              title: "Documents covered",
              list: ["Business content", "Websites and apps", "Marketing and communication", "Technical and commercial documents"],
            },
          ],
        },
        legal: {
          title: "Legal translation",
          cardDesc: "Contracts, judgments, notarial deeds, patents…",
          pageTitle: "Legal translation",
          pageLead: "Law-related documents translated with precise legal terminology.",
          sections: [
            {
              title: "Documents covered",
              list: ["Contracts", "Judgments", "Notarial deeds", "Company statutes", "Terms & conditions", "Powers of attorney", "NDAs", "Patents", "Trademarks", "Immigration documents"],
            },
          ],
        },
        technical: {
          title: "Technical translation",
          cardDesc: "Manuals, notices, specifications…",
          pageTitle: "Technical translation",
          pageLead: "Specialized industry and technology documents with exact terminology.",
          sections: [
            {
              title: "Documents covered",
              list: ["User manuals", "Technical notices", "Industrial documentation", "Specifications", "Automotive documentation", "Aeronautical documentation", "Electronics documentation", "Energy documentation", "Mechanical documentation"],
            },
          ],
        },
        medical: {
          title: "Medical translation",
          cardDesc: "Reports, prescriptions, clinical trials…",
          pageTitle: "Medical translation",
          pageLead: "Medical and pharmaceutical documents with careful terminology.",
          sections: [
            {
              title: "Documents covered",
              list: ["Medical reports", "Prescriptions", "Medical test results", "Patient records", "Clinical trials", "Pharmaceutical leaflets", "Medical devices", "Research protocols"],
            },
          ],
        },
        financial: {
          title: "Financial translation",
          cardDesc: "Balance sheets, annual reports, audits…",
          pageTitle: "Financial translation",
          pageLead: "Economic and financial documents.",
          sections: [
            {
              title: "Documents covered",
              list: ["Balance sheets", "Annual reports", "Financial statements", "Audit reports", "Banking documents", "Insurance", "Taxation", "Financial prospectuses"],
            },
          ],
        },
        commercial: {
          title: "Commercial translation",
          cardDesc: "Catalogues, brochures, tenders…",
          pageTitle: "Commercial translation",
          pageLead: "Business and trade documents.",
          sections: [
            {
              title: "Documents covered",
              list: ["Catalogues", "Brochures", "Sales presentations", "Correspondence", "Tenders", "Price quotes", "Sales reports", "HR documents"],
            },
          ],
        },
        marketing: {
          title: "Marketing translation",
          cardDesc: "Campaigns, slogans, social media…",
          pageTitle: "Marketing translation",
          pageLead: "Communication and advertising adapted to your target market.",
          sections: [
            {
              title: "Documents covered",
              list: ["Ad campaigns", "Slogans", "Newsletters", "Social media", "Press releases", "Marketing flyers", "Email marketing", "Branding"],
            },
          ],
        },
        it: {
          title: "IT translation",
          cardDesc: "Software, APIs, mobile apps…",
          pageTitle: "IT translation",
          pageLead: "Documents from the IT and digital field.",
          sections: [
            {
              title: "Documents covered",
              list: ["Software documentation", "API documentation", "User guides", "User interfaces", "Software", "Video games", "Mobile apps", "Cloud documentation"],
            },
          ],
        },
        scientific: {
          title: "Scientific translation",
          cardDesc: "Papers, theses, publications…",
          pageTitle: "Scientific translation",
          pageLead: "Research documents and scientific publications.",
          sections: [
            {
              title: "Documents covered",
              list: ["Scientific papers", "Publications", "PhD theses", "Dissertations", "Lab reports", "Scientific journals"],
            },
          ],
        },
        digital: {
          title: "Digital translation",
          cardDesc: "Websites, localization, SEO, e-commerce…",
          pageTitle: "Digital translation",
          pageLead: "Web-related services: translation and localization of your platforms.",
          sections: [
            {
              title: "Documents covered",
              list: ["Website translation", "Website localization", "App localization", "Software localization", "SEO translation", "E-commerce translation", "UX/UI translation"],
            },
          ],
        },
        website: {
          title: "Website translation",
          cardDesc: "Corporate sites, e-commerce and apps.",
          pageTitle: "Website translation",
          pageLead: "Adapting your web content to the language and culture of your audience.",
          sections: [
            {
              title: "Documents covered",
              list: ["Corporate sites", "E-commerce stores", "Web applications", "Content and product pages"],
            },
          ],
        },
        audiovisual: {
          title: "Audiovisual translation",
          cardDesc: "Subtitling, dubbing, voice-over…",
          pageTitle: "Audiovisual translation",
          pageLead: "Media and video: subtitling, dubbing and transcription.",
          sections: [
            {
              title: "Documents covered",
              list: ["Subtitling", "Dubbing", "Voice-over", "Transcription", "Script adaptation", "Multilingual subtitling"],
            },
          ],
        },
        tourism: {
          title: "Tourism translation",
          cardDesc: "Guides, menus, hotel websites…",
          pageTitle: "Tourism translation",
          pageLead: "Tourism and hospitality sector, clear and engaging tone.",
          sections: [
            {
              title: "Documents covered",
              list: ["Travel guides", "Brochures", "Menus", "Hotel websites", "Travel agencies", "Tourism apps"],
            },
          ],
        },
        luxury: {
          title: "Luxury translation",
          cardDesc: "Jewelry, watchmaking, fashion, perfumes…",
          pageTitle: "Luxury translation",
          pageLead: "High-end sectors: every word respects the brand image.",
          sections: [
            {
              title: "Documents covered",
              list: ["Jewelry", "Watchmaking", "Fashion", "Perfumes", "Cosmetics", "Luxury hospitality"],
            },
          ],
        },
        interpreting: {
          title: "Interpreting",
          cardDesc: "Conference, professional and remote.",
          pageTitle: "Interpreting",
          pageLead: "Interpreters for your meetings, appointments and events — on-site or remote.",
          sections: [
            {
              title: "Documents covered",
              list: ["Simultaneous interpreting", "Consecutive interpreting", "Liaison interpreting", "Judicial interpreting", "Medical interpreting", "Telephone interpreting", "Video conference interpreting"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "How do I book?", a: "Share the date, duration, languages and mode. We confirm the rate and profile." },
          ],
        },
        simultaneous: {
          title: "Simultaneous interpreting",
          cardDesc: "Real time, in a booth or with a portable system.",
          pageTitle: "Simultaneous interpreting",
          pageLead: "The interpreter translates in real time while the speaker talks. The standard choice for conferences and large multilingual events.",
          sections: [
            {
              title: "When to choose it",
              list: ["Conferences and conventions", "International seminars and forums", "General meetings", "Multilingual training sessions", "Live-streamed events"],
            },
            {
              title: "How we work",
              paragraphs: ["We assign two interpreters per language per half-day, because the task demands sustained concentration. Equipment (booth, headsets, receivers) can be supplied on request."],
              list: ["Two interpreters per language pair", "Soundproof booth or portable system", "Preparatory documents reviewed in advance"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Is equipment required?", a: "Yes, a booth or a portable system with headsets. We can include it in the quote or work with your venue's provider." },
            { q: "Why two interpreters?", a: "Simultaneous interpreting demands extreme focus. Interpreters swap every 20 to 30 minutes to keep quality consistent throughout." },
            { q: "How far ahead should I book?", a: "Ideally two to three weeks for an event, so we can secure the right profiles and equipment. Urgent requests remain possible subject to availability." },
          ],
        },
        consecutive: {
          title: "Consecutive interpreting",
          cardDesc: "The interpreter translates after each turn.",
          pageTitle: "Consecutive interpreting",
          pageLead: "The speaker talks, then the interpreter delivers the message. No equipment needed — ideal for meetings and short interventions.",
          sections: [
            {
              title: "When to choose it",
              list: ["Working meetings and negotiations", "Speeches and ceremonies", "Company and factory visits", "Press conferences", "Small-group technical briefings"],
            },
            {
              title: "How we work",
              paragraphs: ["The interpreter takes notes during the intervention, then renders the message accurately. Allow roughly double the speaking time."],
              list: ["No equipment required", "One interpreter is enough in most cases", "Terminology prepared from your documents"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Consecutive or simultaneous?", a: "Consecutive suits meetings under 20 people and short exchanges. Beyond that, or when time is tight, simultaneous is preferable." },
            { q: "Does it double the meeting length?", a: "Almost: every intervention is delivered twice. We factor this into the time and cost estimate." },
          ],
        },
        liaison: {
          title: "Liaison interpreting",
          cardDesc: "One-to-one or small-group support.",
          pageTitle: "Liaison interpreting",
          pageLead: "An interpreter accompanies you through appointments and small-group exchanges, switching between languages as the conversation flows.",
          sections: [
            {
              title: "When to choose it",
              list: ["Administrative and consular appointments", "Signings at the notary", "Site visits and trade fairs", "Job interviews", "Delegation support"],
            },
            {
              title: "How we work",
              paragraphs: ["The interpreter stays with you for the whole appointment and translates both ways, sentence by sentence. Discretion and neutrality are the rule."],
              list: ["Billed hourly or per half-day", "Travel available within Tunisia and abroad", "Confidentiality guaranteed"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Can the interpreter travel?", a: "Yes, anywhere in Tunisia and abroad. Travel costs are stated in the quote before you confirm." },
            { q: "What is the minimum duration?", a: "Two hours as a rule. Beyond four hours, the half-day rate applies." },
          ],
        },
        judicial: {
          title: "Judicial interpreting",
          cardDesc: "Courts, hearings and notarial deeds.",
          pageTitle: "Judicial interpreting",
          pageLead: "Sworn interpreters for hearings, depositions and official acts, where every word carries legal weight.",
          sections: [
            {
              title: "When to choose it",
              list: ["Hearings and trials", "Depositions and witness statements", "Notarial deeds and signings", "Immigration and asylum procedures", "Interviews and investigations"],
            },
            {
              title: "How we work",
              paragraphs: ["Only sworn interpreters accredited by the courts handle these assignments. They master procedural terminology and are bound by professional secrecy."],
              list: ["Interpreters accredited by Tunisian courts", "Faithful rendering, with no interpretation or additions", "Absolute professional secrecy"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Is the interpreter sworn?", a: "Yes. For any judicial procedure we assign only sworn interpreters recognised by the courts." },
            { q: "Can you step in urgently?", a: "We handle urgent summonses subject to availability. Contact us as soon as you receive the hearing date." },
          ],
        },
        phone: {
          title: "Telephone interpreting",
          cardDesc: "An interpreter on the line within minutes.",
          pageTitle: "Telephone interpreting",
          pageLead: "An interpreter joins you by phone for your remote calls and procedures — no travel, no setup.",
          sections: [
            {
              title: "When to choose it",
              list: ["Calls with a foreign authority", "Dealings with a bank or insurer", "Booking medical appointments abroad", "Following up a consular file", "Urgent, one-off needs"],
            },
            {
              title: "How we work",
              paragraphs: ["You tell us the language and preferred slot. The interpreter joins a three-way call and translates live."],
              list: ["Billed per minute or in 15-minute blocks", "Fast matching based on language", "No equipment or software to install"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "How quickly is an interpreter available?", a: "For common languages, often the same day. For rare languages, allow 24 to 48 hours." },
            { q: "How does the call work?", a: "We set up a three-way call: you, the other party and the interpreter. Nothing to install on your side." },
          ],
        },
        video: {
          title: "Video conference interpreting",
          cardDesc: "Zoom, Teams, Meet — remote and multilingual.",
          pageTitle: "Video conference interpreting",
          pageLead: "Your online meetings become multilingual: the interpreter joins your video call and translates live.",
          sections: [
            {
              title: "When to choose it",
              list: ["International team meetings", "Webinars and online presentations", "Remote interviews and defences", "Multilingual board meetings", "Consular appointments by video"],
            },
            {
              title: "How we work",
              paragraphs: ["We work on Zoom, Teams, Google Meet and the main platforms. In simultaneous mode we use language channels where the platform supports them."],
              list: ["Compatible with Zoom, Teams, Google Meet, Webex", "Simultaneous or consecutive mode depending on the format", "Technical test before the meeting"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Which platforms do you support?", a: "Zoom, Microsoft Teams, Google Meet, Webex and most video conferencing tools. Tell us yours when booking." },
            { q: "Do I need a specific licence?", a: "For simultaneous mode with separate language channels, Zoom requires a compatible licence. Otherwise we work consecutively, with no technical constraints." },
          ],
        },
        transcription: {
          title: "Transcription & retranscription",
          cardDesc: "Your audio and video files put into writing.",
          pageTitle: "Transcription & retranscription",
          pageLead: "We turn your audio and video recordings into faithful written documents, in the original language or translated.",
          sections: [
            {
              title: "What we transcribe",
              list: ["Meetings, committees and assemblies", "Interviews", "Conferences and training sessions", "Hearings and depositions", "Podcasts and video content", "Surveys and qualitative research"],
            },
            {
              title: "Delivery formats",
              paragraphs: ["You choose the level of finish based on the intended use: full verbatim for legal purposes, or a clean, readable version for publication."],
              list: ["Full verbatim (word for word, hesitations included)", "Cleaned-up and proofread version", "Timestamps and speaker identification", "Delivered as Word, PDF or a subtitle file"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "What is the difference between transcription and retranscription?", a: "Transcription puts a recording into writing in its original language. Retranscription adds translation into another language." },
            { q: "How is the price calculated?", a: "By recording length, taking into account audio quality, number of speakers and the level of finish requested." },
            { q: "What if the audio quality is poor?", a: "We listen to it before confirming the quote. Genuinely inaudible passages are flagged in the document rather than guessed." },
          ],
        },
        voiceover: {
          title: "Voice-over",
          cardDesc: "Professional voice-over, dubbing and subtitling.",
          pageTitle: "Voice-over",
          pageLead: "We give your content a voice in your audience's language: script translation, recording and synchronisation.",
          sections: [
            {
              title: "What we produce",
              list: ["Corporate and institutional videos", "E-learning modules and tutorials", "Adverts and radio spots", "Documentaries and reports", "Phone greeting messages", "Multilingual subtitling"],
            },
            {
              title: "Our process",
              paragraphs: ["The script is first translated and adapted to the timing of each sequence, then recorded by a native voice actor, and finally synchronised to your video."],
              list: ["Script translated and adapted to timing", "Native voices, male and female, several tones", "Studio recording", "Mixing and synchronisation to your edit"],
            },
          ],
          faqTitle: "FAQ",
          faq: [
            { q: "Can we choose the voice?", a: "Yes. We send you samples of the voices available in the target language and you approve one before recording." },
            { q: "Voice-over or dubbing?", a: "Voice-over layers a narrative voice over the original track. Dubbing replaces the dialogue with lip-sync. We offer both." },
            { q: "Do you supply subtitles too?", a: "Yes, as an SRT or VTT file, or burned directly into the video." },
          ],
        },
        general: { title: "General translation", cardDesc: "Translation of everyday personal and administrative documents." },
        specialized: { title: "Specialized translation", cardDesc: "Legal, technical, medical, financial and commercial translation." },
        personal: { title: "Personal documents", cardDesc: "Civil status records, passports, ID cards and certificates." },
        administrative: { title: "Administrative documents", cardDesc: "Licences, police records, proofs and various attestations." },
        academic: { title: "Diplomas & certificates", cardDesc: "Translation of diplomas, transcripts and school certificates." },
        legalDocs: { title: "Legal documents", cardDesc: "Contracts, judgments, notarial deeds and powers of attorney." },
        commercialDocs: { title: "Commercial documents", cardDesc: "Catalogues, brochures, tenders and business reports." },
        medicalDocs: { title: "Medical documents", cardDesc: "Reports, prescriptions, analyses and health records." },
        medicalInterpreting: { title: "Medical interpreting", cardDesc: "Support for consultations and health records." },
        businessInterpreting: { title: "Business interpreting", cardDesc: "Meetings, negotiations and corporate events." },
        remoteInterpreting: { title: "Remote interpreting", cardDesc: "By phone or video conference, anywhere in the world." },
      },
    },
    translators: translatorsEn,
    quoteWizard: quoteWizardEn,
    quoteForm: quoteFormEn,
    dashboard: dashboardEn,
    why: {
      title: 'Why choose Tarjemlek?',
      quality: 'Certified quality',
      qualityDesc: 'Sworn translators approved by Tunisian courts.',
      speed: 'Fast delivery',
      speedDesc: 'Certified PDF within 48h, 24h express option available.',
      price: 'Transparent pricing',
      priceDesc: 'Instant quote, no hidden fees. Secure payment.',
      support: 'Multilingual support',
      supportDesc: 'Assistance in French, Arabic and English, 7 days a week.',
      guarantee: 'Zero rejection guarantee',
      guaranteeDesc: 'Free retranslation if rejected by an official authority.',
      digital: 'Certified PDF + originals',
      digitalDesc: 'Digital translation by email or client portal. Paper originals shipped when required by authorities.',
    },
    whyChoose: {
      kicker: 'Tarjemlek',
      title: 'Why choose us',
      intro:
        'Official documents, business content or specialist files: Tarjemlek assigns each project to a translator who genuinely knows the subject.',
      cta: 'Explore all our services',
      learnMore: 'View this service',
      commitmentsTitle: 'Our commitments',
      services: [
        {
          title: 'Sworn translation',
          text: 'Civil-status records, diplomas and administrative documents translated with an approved translator\'s stamp and signature.',
        },
        {
          title: 'Website translation',
          text: 'Corporate sites, online stores and apps adapted to your market without losing your meaning or brand voice.',
        },
        {
          title: 'Technical translation',
          text: 'Manuals, instructions, specifications and product sheets translated with terminology that stays consistent across documents.',
        },
        {
          title: 'Legal translation',
          text: 'Contracts, judgments, statutes and notarial deeds handled by translators trained in Tunisian and international law.',
        },
        {
          title: 'Medical translation',
          text: 'Certificates, reports, test results and care files translated accurately and kept strictly confidential.',
        },
        {
          title: 'Certified translation',
          text: 'Translations true to the original, accepted by authorities, embassies, universities and companies.',
        },
      ],
      items: [
        {
          title: 'Quality',
          text: 'Every translation is produced by a sworn translator approved by Tunisian courts, then proofread before it is sent.',
        },
        {
          title: 'Confidentiality',
          text: 'Your files travel over a secure connection, stay covered by professional secrecy and are never shared.',
        },
        {
          title: 'Turnaround',
          text: 'Delivered as a PDF within 48 hours, or 24 hours with express. The deadline is confirmed before work starts.',
        },
        {
          title: 'Pricing',
          text: 'The quoted price covers translation, proofreading, delivery and corrections. No extra charges after ordering.',
        },
        {
          title: '24/7 support',
          text: 'Contact us anytime via chat, email, SMS, phone or WhatsApp. A fast reply, whatever your time zone.',
        },
      ],
    },
    trust: {
      title: 'Your trust, our commitment',
      subtitle: 'A network of approved professionals serving Tunisians abroad and the Mediterranean basin',
      sworn: 'Sworn translators',
      swornDesc: 'Approved by Tunisian courts — accepted by authorities.',
      guarantee: 'Zero rejection guarantee',
      guaranteeDesc: 'Free retranslation if your document is rejected by an authority.',
      pricing: 'Transparent pricing',
      pricingDesc: 'Instant quote before signup — no hidden fees.',
      digital: 'Flexible delivery',
      digitalDesc: 'Certified PDF within 48h — paper originals by mail when necessary.',
      whatsapp: 'WhatsApp 24/7',
      whatsappDesc: 'Instant support for urgent requests and order tracking.',
      secure: 'Secure payment',
      secureDesc: 'Card, bank transfer or mobile payment — automatic invoice.',
    },
    useCases: {
      title: 'For all your procedures',
      subtitle: 'Embassies, visas, universities, diplomas and administrative procedures abroad',
      visa: 'Visa & residence permit',
      visaDesc: 'Consular files, medical certificates, proof of resources.',
      immigration: 'Immigration & naturalization',
      immigrationDesc: 'Criminal record, civil status documents, family reunification files.',
      studies: 'Studies & equivalence',
      studiesDesc: 'Diplomas, transcripts, theses for university enrollment.',
      marriageAbroad: 'Marriage abroad',
      marriageAbroadDesc: 'Birth certificates, single status certificates, notarized translations.',
      business: 'Business setup',
      businessDesc: 'Statutes, commercial contracts, registration documents.',
      legal: 'Legal procedures',
      legalDesc: 'Judgments, powers of attorney, contracts and court documents.',
    },
    pricing: {
      title: 'Transparent pricing',
      subtitle: 'Publicly displayed prices — instant quote without registration',
      perPage: 'TND / page',
      from: 'From',
      standard: 'Standard',
      express: 'Express',
      urgent: 'Urgent',
      standardDelay: '4-5 days',
      expressDelay: '48h',
      urgentDelay: '24h',
      note: 'Express surcharge ×1.5 — urgent ×2. Apostille 10–15 TND/doc. (official rate). Indicative EUR for abroad.',
      cta: 'Calculate my quote',
    },
    qa: {
      title: 'Our quality assurance process',
      subtitle: 'Full transparency at every step — from receipt to delivery',
      step1: 'File assessment',
      step1Desc: 'Verification of readability, completeness and suitability of the source document.',
      step2: 'Expert translation',
      step2Desc: 'Sworn translator specialized in the document domain.',
      step3: 'Native proofreading',
      step3Desc: 'Linguistic and terminological review by a qualified proofreader.',
      step4: 'Official certification',
      step4Desc: 'Application of stamp, signature and legal mention of the sworn translator.',
      step5: 'Secure delivery',
      step5Desc: 'Certified PDF sent by email or download from client portal.',
    },
    legal: {
      title: 'Legal notice & terms',
      refundTitle: 'Cancellation and refund policy',
      refundText: 'Free cancellation before translation begins. Full refund if cancelled within 2 hours of payment. No refund after certified document delivery, except under zero rejection guarantee.',
      termsTitle: 'General terms of sale',
      termsText: 'Tarjemlek provides sworn translations by approved translators. Stated deadlines are estimates in business days. Client is responsible for scan quality.',
      privacyTitle: 'Privacy',
      privacyText: 'Your documents are handled strictly confidentially and deleted from our servers 90 days after delivery, unless otherwise requested.',
    },
    faq: {
      title: 'Frequently asked questions',
    },
    ecosystem: {
      title: 'An ecosystem of professionals at your service',
      subtitle: 'Translation, apostille, legal advice and official documents — packaged offers for Tunisians abroad',
      translator: 'Sworn translators',
      translatorDesc: 'Certified translations accepted by embassies, universities and authorities.',
      notary: 'Notaries',
      notaryDesc: 'Apostille, legalization and certification of your documents for international use.',
      lawyer: 'Lawyers',
      lawyerDesc: 'Legal advice and support for your procedures abroad.',
      bailiff: 'Bailiffs',
      bailiffDesc: 'Service of process, reports and procedures for your official files.',
      note: 'Tarjemlek brings these professionals together to offer simplified pathways from Tunisia to the world.',
    },
    cta: {
      title: 'Ready to translate your documents?',
      subtitle: 'Get a free quote in less than 60 business minutes.',
      button: 'Order now',
    },
    reviews: {
      title: 'Customer satisfaction',
      subtitle: 'Tunisians abroad and institutions trust us for their official documents',
      score: '4.9',
      basedOn: 'Based on 340+ verified reviews',
      r1: {
        text: 'Birth certificate translation delivered in 36h. Accepted without issue at the Tunisian embassy in Paris.',
        name: 'Sami B.',
        role: 'Tunisian resident, France',
        doc: 'Birth certificate',
      },
      r2: {
        text: 'Had my diploma translated for university enrollment in Germany. Simple process, clear pricing.',
        name: 'Ines M.',
        role: 'Tunisian student, Germany',
        doc: 'University diploma',
      },
      r3: {
        text: 'Excellent support for my visa application. Translation + apostille in one single process.',
        name: 'Karim H.',
        role: 'Tunisian resident, Canada',
        doc: 'Criminal record',
      },
      r4: {
        text: 'Our Mediterranean company uses Tarjemlek for all official documents. Reliable and fast.',
        name: 'Laura P.',
        role: 'HR Manager, Italy',
        doc: 'Commercial contract',
      },
      r5: {
        text: 'Good experience for my parents\' power of attorney in Tunisia. Everything was accepted abroad.',
        name: 'Amira T.',
        role: 'Tunisian resident, Belgium',
        doc: 'Power of attorney',
      },
      r6: {
        text: 'My marriage certificate translation was accepted at the consulate without any problem. Highly recommended.',
        name: 'Youssef K.',
        role: 'Tunisian resident, Switzerland',
        doc: 'Marriage certificate',
      },
    },
    footer: {
      description:
        'Tarjemlek supports Tunisians living abroad and Mediterranean institutions with their official document procedures.',
      services: 'Services',
      company: 'Company',
      legal: 'Legal notice',
      privacy: 'Privacy',
      rights: 'All rights reserved.',
      address: 'Tunis, Tunisia',
    },
    contact: {
      title: 'Contact us',
      subtitle: 'Our team responds within 60 minutes on business days.',
      civility: 'Title',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      message: 'Your message',
      send: 'Send',
      success: 'Message sent! We will reply shortly.',
      badge: 'We are here to help',
      breadcrumbHome: 'Home',
      infoTitle: 'Contact details',
      formTitle: 'Write to us',
      formHint: 'Describe your need and we will get back to you shortly.',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      addressLabel: 'Address',
      hoursLabel: 'Opening hours',
      hoursValue: 'Mon – Sat · 8:00 – 20:00',
      whatsapp: 'Chat on WhatsApp',
      successAgain: 'Send another message',
      optional: 'optional',
      messagePlaceholder: 'Documents to translate, language pair, deadline…',
    },
    order: {
      title: 'Order a translation',
      subtitle: 'Choose your document, languages and complete your order in a few steps.',
      step: 'Step',
      of: 'of',
      stepDoc: 'Document',
      stepFiles: 'Files',
      stepSummary: 'Confirm',
      chooseDoc: 'Choose a document type',
      chooseLang: 'Choose a language pair',
      allCategories: 'All',
      searchDocs: 'Search a document…',
      noDocs: 'No documents found.',
      perPage: '/ page',
      yes: 'Yes',
      no: 'No',
      stepDocHint: 'Select the document, then your translation options.',
      stepFilesHint: 'Add your files and any useful details.',
      stepSummaryHint: 'Review the summary before confirming.',
      deliveryDigitalShort: 'PDF by email',
      deliveryPhysicalShort: 'Paper + PDF (+15 TND)',
      docType: 'Document type',
      langPair: 'Language pair',
      pages: 'Number of pages',
      urgency: 'Desired deadline',
      standard: 'Standard (4-5 days)',
      express: 'Express (48h)',
      urgent: 'Urgent (24h)',
      upload: 'Upload your documents',
      uploadHint: 'PDF, JPG, PNG — max 10 MB per file',
      dragDrop: 'Drag files here or click to browse',
      info: 'Additional information',
      infoPlaceholder: 'Destination country, special procedure, legalization...',
      next: 'Next',
      prev: 'Previous',
      submit: 'Confirm order',
      summary: 'Summary',
      estimated: 'Estimate',
      delivery: 'Delivery method',
      deliveryDigital: 'Digital (certified PDF by email)',
      deliveryPhysical: 'Paper + digital — originals if required (+15 TND)',
      apostille: 'Apostille / legalization',
      apostilleAdd: 'Add apostille (10–15 TND / doc., official rate)',
      apostilleRange: '10–15 TND / doc. (official rate)',
      eurNote: 'EUR amounts are indicative for clients abroad.',
      successTitle: 'Order confirmed!',
      successText: 'We will review your documents and send a confirmation email within 60 minutes.',
      backHome: 'Back to home',
      selectDoc: 'Select a document to see the estimate',
      files: 'Files',
      fileUnit: 'file(s)',
      loginBanner: 'Log in to confirm your order and receive your translations in your client area.',
      loginToSubmit: 'Log in to confirm',
    },
    auth: {
      loginTitle: 'Log in',
      loginSubtitle: 'Access your Tarjemlek account',
      registerTitle: 'Create an account',
      registerSubtitle: 'An account is required to order and receive your documents',
      email: 'Email',
      password: 'Password',
      name: 'Full name',
      loginButton: 'Log in',
      registerButton: 'Create my account',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      registerLink: 'Sign up',
      loginLink: 'Log in',
      logout: 'Log out',
      dashboard: 'Dashboard',
      myAccount: 'My account',
      loginRequiredText: 'You can prepare your order freely. To confirm it, log in or create an account.',
      invalidCredentials: 'Incorrect email or password',
      emailNotFound: 'This email does not exist in our database.',
      inactive: 'Your account is disabled. Please contact the administrator.',
      currentPassword: 'Current password',
      confirmNewPassword: 'Confirm new password',
      changePassword: 'Change password',
      passwordChanged: 'Password updated successfully.',
      wrongPassword: 'Current password is incorrect.',
      emailExists: 'This email is already in use',
      guestAccountExists: 'You have already ordered with this email. An account activation email has just been sent to you.',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordHint: 'Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character.',
      passwordReqMin: 'At least 8 characters',
      passwordReqUpper: 'One uppercase letter',
      passwordReqLower: 'One lowercase letter',
      passwordReqNumber: 'One number',
      passwordReqSpecial: 'One special character',
      passwordsMismatch: 'Passwords do not match',
      invalidEmail: 'Invalid email address',
      invalidPayload: 'Please fill in all required fields',
      termsNotAccepted: 'You must accept the terms of service',
      organizationNameRequired: 'Company or organization name is required',
      registerSuccess: 'Your account has been created successfully. Redirecting…',
      welcomeBack: 'Log in',
      loginFormHint: 'Log in to your account.',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      perkSecure: 'Secure payment and data',
      perkOrders: 'Track your orders online',
      perkDocs: 'Certified PDFs ready to download',
      forgotLink: 'Forgot password?',
      forgotTitle: 'Reset password',
      forgotHint: 'Enter your email to get a reset link.',
      forgotButton: 'Send link',
      forgotSent: 'If an account exists, an email with a reset link has been sent. Please check your inbox.',
      resetContinue: 'Continue reset',
      resetTitle: 'New password',
      resetHint: 'Choose a password with at least 6 characters.',
      resetToken: 'Token',
      newPassword: 'New password',
      resetButton: 'Save',
      resetDone: 'Password updated. Redirecting…',
      invalidToken: 'Invalid or expired link',
    },
    about: {
      title: 'About Tarjemlek',
      subtitle: 'Your professional translation and interpreting platform',
      heroTagline: 'Translation, interpreting and document services — simple, reliable and accessible everywhere.',
      whoWeAreTitle: 'Who we are',
      whoWeAreIntro: 'Tarjemlek is a Tunisian platform that simplifies access to document and language services for individuals, businesses and institutions.',
      mission: 'Make every translation, certification and interpreting request simple, reliable and accessible, wherever you are.',
      vision: 'Become the leading linguistic and legal bridge between Tunisia, Europe and the rest of the world.',
      values: 'Rigour, confidentiality, responsiveness and professionalism',
      positioning: 'Professional translation and interpreting',
      servicesTitle: 'Our services',
      servicesIntro: 'Tailored solutions for every need, delivered by qualified experts.',
      professionalTranslation: 'Professional translation',
      officialTranslation: 'Official translation',
      interpreting: 'Interpreting',
      additionalServices: 'Additional services',
      teamTitle: 'Our team',
      teamIntro: 'A network of experienced professionals recognised in their fields.',
      translators: 'Translators',
      interpreters: 'Interpreters',
      lawyers: 'Lawyers',
      notaries: 'Notaries',
      processTitle: 'Our process',
      processIntro: 'A clear and transparent path, from request to delivery.',
      processSteps: [
        { title: 'Client request', desc: 'You upload your document or describe your needs.' },
        { title: 'Analysis', desc: 'We assess the document type, language and urgency.' },
        { title: 'Quote', desc: 'You receive a clear price and deadline.' },
        { title: 'Payment', desc: 'Secure online payment.' },
        { title: 'Assignment', desc: 'A qualified professional handles your file.' },
        { title: 'Execution', desc: 'Translation, revision and formatting to standard.' },
        { title: 'Verification', desc: 'Quality control and certification when required.' },
        { title: 'Delivery', desc: 'Receive your document by email or paper, as you choose.' },
      ],
      whyTitle: 'Why choose us?',
      whyIntro: 'We bring expertise and organisation to every project.',
      whyPoints: [
        { title: 'Specialised translators', desc: 'Each file is assigned to a domain expert.' },
        { title: 'Multiple languages', desc: 'Broad coverage for your multilingual needs.' },
        { title: 'Domain expertise', desc: 'Legal, medical, technical, commercial, academic.' },
        { title: 'Professional verification', desc: 'Systematic proofreading and quality control.' },
        { title: 'Order tracking', desc: 'A dedicated contact and follow-up at every step.' },
        { title: 'Deadline respect', desc: 'Delivery on time, including urgent requests.' },
        { title: 'Confidentiality', desc: 'Your documents are handled with the highest security.' },
      ],
      commitmentTitle: 'Our commitment',
      commitmentIntro: 'We stand by strong values to give you peace of mind.',
      commitments: [
        'Quality',
        'Confidentiality',
        'Reliability',
        'Deadline respect',
        'Client support',
      ],
      ctaTitle: 'Need a translation or an interpreter?',
      ctaText: 'Order online or contact us for a personalised quote.',
      orderButton: 'Order online',
      contactButton: 'Contact us',
    },
    translator: {
      title: 'Join our translator network',
      subtitle: 'Over 100 certified translators already work with Tarjemlek.',
      apply: 'Apply now',
      civility: 'Title',
      name: 'Full name',
      email: 'Email',
      langPairs: 'Language pairs',
      langPairsHint: 'Add one or more pairs (source language → target language).',
      fromLang: 'From',
      toLang: 'To',
      addPair: 'Add',
      selectLang: 'Select',
      pairRequired: 'Add at least one language pair.',
      specialization: 'Specialization',
      experience: 'Experience (years)',
      cv: 'CV / Portfolio (PDF)',
      choose: '—',
      specialties: {
        legal: 'Legal',
        medical: 'Medical',
        academic: 'Academic',
        commercial: 'Commercial',
        technical: 'Technical',
      },
      perk1: 'Varied international projects',
      perk2: 'Competitive pay',
      perk3: 'Network of 100+ translators',
    },
  },
};

export const faqItems = {
  fr: [
    {
      q: 'Qu\'est-ce qu\'une traduction assermentée ?',
      a: 'C\'est une traduction officielle réalisée par un traducteur agréé par un tribunal, accompagnée de son cachet et signature. Elle a la même valeur légale que l\'original pour les administrations.',
    },
    {
      q: 'Mes traductions sont-elles acceptées en Tunisie et à l\'étranger ?',
      a: 'Oui. Nos traducteurs sont agréés et nos traductions respectent les normes tunisiennes et internationales. Précisez le pays de destination lors de votre commande.',
    },
    {
      q: 'Quels sont les délais de livraison ?',
      a: 'Standard : 4-5 jours ouvrés. Express : 48h. Urgent : 24h (majoration). Pour les dossiers volumineux, un délai personnalisé vous sera communiqué.',
    },
    {
      q: 'Comment recevoir mes documents traduits ?',
      a: 'Par email au format PDF certifié. Les originaux papier avec cachet humide peuvent être envoyés par courrier en option.',
    },
    {
      q: 'Quels formats de fichiers acceptez-vous ?',
      a: 'PDF, JPG, PNG et Word. Assurez-vous que vos scans sont lisibles et complets (toutes les pages).',
    },
    {
      q: 'Proposez-vous la légalisation ou l\'apostille ?',
      a: 'Oui, nous accompagnons vos démarches de légalisation et d\'apostille auprès des autorités compétentes en Tunisie.',
    },
  ],
  ar: [
    {
      q: 'ما هي الترجمة المعتمدة؟',
      a: 'ترجمة رسمية يقوم بها مترجم معتمد لدى محكمة، مرفقة بختمه وتوقيعه. لها نفس القيمة القانونية للأصل لدى الإدارات.',
    },
    {
      q: 'هل تُقبل ترجماتي في تونس وخارجها؟',
      a: 'نعم. مترجمونا معتمدون وترجماتنا تلتزم بالمعايير التونسية والدولية. حدد بلد الوجهة عند الطلب.',
    },
    {
      q: 'ما هي مواعيد التسليم؟',
      a: 'عادي: 4-5 أيام عمل. سريع: 48 ساعة. عاجل: 24 ساعة (برسوم إضافية). للملفات الكبيرة، نبلغك بموعد مخصص.',
    },
    {
      q: 'كيف أستلم وثائقي المترجمة؟',
      a: 'عبر البريد الإلكتروني بصيغة PDF معتمدة. النسخ الورقية الأصلية بالختم الرطب يمكن إرسالها بالبريد كخيار.',
    },
    {
      q: 'ما صيغ الملفات المقبولة؟',
      a: 'PDF, JPG, PNG و Word. تأكد أن المسح واضح وكامل (جميع الصفحات).',
    },
    {
      q: 'هل تقدمون التصديق أو الأبوستille؟',
      a: 'نعم، نرافقك في إجراءات التصديق والأبوستille لدى السلطات المختصة في تونس.',
    },
  ],
  en: [
    {
      q: 'What is a sworn translation?',
      a: 'An official translation performed by a court-approved translator, with stamp and signature. It has the same legal value as the original for authorities.',
    },
    {
      q: 'Are my translations accepted in Tunisia and abroad?',
      a: 'Yes. Our translators are approved and our translations meet Tunisian and international standards. Specify the destination country when ordering.',
    },
    {
      q: 'What are the delivery times?',
      a: 'Standard: 4-5 business days. Express: 48h. Urgent: 24h (surcharge). For large files, a custom deadline will be provided.',
    },
    {
      q: 'How do I receive my translated documents?',
      a: 'By email as certified PDF. Paper originals with wet stamp can be sent by mail as an option.',
    },
    {
      q: 'What file formats do you accept?',
      a: 'PDF, JPG, PNG and Word. Ensure scans are readable and complete (all pages).',
    },
    {
      q: 'Do you offer legalization or apostille?',
      a: 'Yes, we assist with legalization and apostille procedures with competent authorities in Tunisia.',
    },
  ],
};
